<template>
  <div v-if="getPermission.opcockpiti.view">

    <ticket-management ref="TicketManagement" mode="YY" :action="updateTicket"/>

    <walk-in-form ref="WalkInForm" mode="YY"/>
    <inbound-remark-form ref="InboundRemarkForm" mode="YY" :onRefresh="updateRemark"/>

     <bol-photo-Zoom-form ref="BolPhotoZoomForm" :on-data-refresh="updatePhoto"/>
     <bol-photo-form ref="BolPhotoForm" :on-data-refresh="updatePhoto"/>
     <report-layout-form ref="UpdateLayoutForm" mode="update" :onUpdate="doupdate"/>
     <report-layout-form ref="CreateLayoutForm" mode="create" :onUpdate="docreate"/>


         <md-dialog :md-active.sync="isPictureModalShowing">
      <md-dialog-content>
        <h1>Photos</h1>
        <calling-api path="/api/w/ccic/photo/get">
        <div v-if="photos.length === 0">
          <h3>You don't have any scan wegiht ticket photo</h3>
        </div>
        <div v-else>
          <view-image  :key="p.photoUrl" :src="p.photoUrl" v-for="p in photos">
            <h3>Type: {{p.title}}</h3>
            <p>File Name: {{getPhotoName(p)}}</p>
            
          </view-image>
        </div>
          
        </calling-api>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="isPictureModalShowing = false">Close</md-button>
      </md-dialog-actions>
    </md-dialog>


     <md-dialog :md-active.sync="isFilterModalShowing" >
       <div> 
        <md-dialog-title>Filter</md-dialog-title>
         <md-button class="custButtonInbound md-raised icon1" @click="isFilterModalShowing = false" >Close</md-button>
         <md-button class="custButtonInbound md-primary md-raised icon1" @click="doSearch('0')">Search</md-button>
         
         
      </div>

      <md-dialog-content>
        
        <!-- <h1>Filter</h1> -->
       
        <div class = "inputBoxDouble" >

          <div class = "inputBoxSpace" >
             <md-field>
                <label>IBS</label>
                <md-input v-model="searchRequest.inboundShipment"/>
            </md-field>
          </div>

          <div class = "inputBoxSpace" >
             <md-field>
                <label>PO</label>
                <md-input v-model="searchRequest.po"/>
            </md-field>
          </div>
             
        
          <!-- <div class = "inputBoxSpace" >
              <datepicker v-model="searchRequest.apptDate">
                <label>Appointment Date</label>
              </datepicker>
        </div> -->

              

        </div>

        <!-- <div class = "inputBoxSpace" >
             <auto-complete-master-data-select
                                                group="REC_WINDOW"
                                                label="Receiving Windows"
                                                :init-value="searchRequest.receivingWindows"
                                                :on-item-changed="handleWindowsChanged"
                                                >
            </auto-complete-master-data-select>
        </div> -->


        <div class = "inputBoxDouble" >

          <div class = "inputBoxSpace" >
             <!-- <md-field>
                <label>Status</label>
                <md-input v-model="searchRequest.inboundStatus"/>
            </md-field> -->
            
             <auto-complete-master-data-select
                                                group="INBOUND_STATUS"
                                                label="Status"
                                                :init-value="searchRequest.inboundStatus"
                                                :on-item-changed="handleStatusChanged"
                                                >
            </auto-complete-master-data-select>
            
          </div>
             
          <div class = "inputBoxSpace" >
             <!-- <md-field>
                <label>IBS Type</label>
                <md-input v-model="searchRequest.ibs_type"/>
            </md-field> -->
            <auto-complete-master-data-select
                                                group="IBS_TYPE"
                                                label="IBS Type"
                                                :init-value="searchRequest.ibs_type"
                                                :on-item-changed="handleIBSChanged"
                                                >
            </auto-complete-master-data-select>
          </div>

        </div>

        <div class = "inputBoxDouble" >

          <div class = "inputBoxSpace" >
             <md-field>
                <label>Weight Ticket</label>
                <md-input v-model="searchRequest.scaleTicket"/>
            </md-field>
          </div>
             
          <div class = "inputBoxSpace" >
             <md-field>
                <label>Driver</label>
                <md-input v-model="searchRequest.moveInBy"/>
            </md-field>
          </div>

        </div>

        <div class = "inputBoxDouble" >

          <div class = "inputBoxSpace" >
             <md-field>
                <label>Supplier</label>
                <md-input v-model="searchRequest.supplier_name"/>
            </md-field>
          </div>
             
          <div class = "inputBoxSpace" >
             <md-field>
                <label>BOL</label>
                <md-input v-model="searchRequest.bol"/>
            </md-field>
          </div>

        </div>

        <div class = "inputBoxDouble" >

          <div class = "inputBoxSpace" >
             <md-field>
                <label>Trucker Name</label>
                <md-input v-model="searchRequest.trucker_name"/>
            </md-field>
          </div>
             
          <div class = "inputBoxSpace" >
             <md-field>
                <label>Material</label>
                <md-input v-model="searchRequest.matnr_desc"/>
            </md-field>
          </div>

        </div>

        <div class = "inputBoxDouble" >

          <div class = "inputBoxSpace" >
             <md-field>
                <label>QC Issue</label>
                <md-input v-model="searchRequest.qcIssue"/>
            </md-field>
          </div>
             
          <div class = "inputBoxSpace" >
              <datepicker v-model="searchRequest.ciDate">
                <label>Check In Date</label>
              </datepicker>
            
          </div>

        </div>

        <div class = "inputBoxDouble" >

          <div class = "inputBoxSpace" >
             <md-field>
                <label>Weight Different</label>
                <md-input v-model="searchRequest.weightDifferent"/>
            </md-field>
          </div>
             
        </div>


      </md-dialog-content>
      <!-- <md-dialog-actions>
        <download-pictures-button :zip-file-name="photoZipFileName"
                                  :file-prefix-for-each-file="filePrefixForEachFile"
                                  :pics="photos.map(it=>it.photoUrl)"/>
        <md-button class="md-primary" @click="isPictureModalShowing = false">Close</md-button>
      </md-dialog-actions> -->
    </md-dialog>

    
    <WindowPortal v-model="weightTicketStatus">
      <button id="printf" onclick="window.print()">Print this page</button>
      <div style="height: 15px"></div>
        <h1 class = "wtheading1 wtcenterPrint">{{weightTicketItem.company}}</h1>
        <dir hight= 10px></dir>
        <h1 class = "wtheading2 wtcenterPrint">{{weightTicketItem.add1}}</h1>
        <h1 class = "wtheading2 wtcenterPrint">{{weightTicketItem.add2}}</h1>
        <!-- <dir hight= 10px></dir> -->
        <h1 class = "wtheading2 wtcenterPrint">Inbound</h1>
        <!-- <h1 class = "heading2 centerPrint">Receiving Window: {{weightTicketItem.receivingWindows}}</h1> -->
        <!-- <h1 class = "heading2 centerPrint"><qrcode-vue :value="weightTicketItem.inboundShipment"/></h1>
        <h1 class = "heading2 centerPrint">IBS: {{weightTicketItem.inboundShipment}}</h1> -->

        <!-- <div style="height: 10px"></div> -->
        <div class ="hContainer" >
          <div class = "item0"></div>
          <div class = "item0">Rec.Window: {{weightTicketItem.receivingWindows}}
            {{weightTicketItem.inboundShipment}}</div>
          <div class = "item0"><qrcode-vue :value="weightTicketItem.inboundShipment"/></div>
        </div>
    
        <table id= "inboundData">    
          <tr>
            <th>Weight Ticket #:</th>
            <td>{{weightTicketItem.scaleTicket}}/{{weightTicketItem.scanWt}}</td>
          </tr>

          <tr>
            <th>IBS #:</th>
            <td>{{ weightTicketItem.inboundShipment}}</td>
          </tr>
          <tr>
            <th>PO #:</th>
            <td>{{weightTicketItem.po}}</td>
          </tr>

          <!-- <tr>
            <th>Appointment Date:</th>
            <td>{{weightTicketItem.apptDate | date}}</td>
          </tr> -->
          <tr>
            <th>Appointment Date/time:</th>
            <td>{{weightTicketItem.apptDate | date}} {{weightTicketItem.apptTime}}</td>
          </tr>
          
          <!-- <tr>
            <th>Check in date:</th>
            <td>{{weightTicketItem.ciDate | date}}</td>
          </tr> -->
          <tr>
            <th>Check in Date/time:</th>
            <td>{{weightTicketItem.ciDate | date}} {{weightTicketItem.ciDate | time}}</td>
          </tr>
          <!-- <tr>
            <th>Scale in Date:</th>
            <td>{{weightTicketItem.gwDate | date}}</td>
          </tr> -->
          <tr>
            <th>Scale in Date/time:</th>
            <td>{{weightTicketItem.gwDate | date}} {{weightTicketItem.gwDate | time}}</td>
          </tr>
          <!-- <tr>
            <th>Scale out Date:</th>
            <td>{{weightTicketItem.twDate | date}}</td>
          </tr> -->
          <tr>
            <th>Scale out Date/time:</th>
            <td>{{weightTicketItem.twDate | date}} {{weightTicketItem.twDate | time}}</td>
          </tr>
          <tr>
            <th>Gross Weight:</th>
            <td>{{weightTicketItem.deductedVGMWeight}} lb</td>
          </tr>
          <tr>
            <th>Tare Weight:</th>
            <td>{{parseInt(weightTicketItem.tareWeight)}} lb</td>
          </tr>
          <tr>
            <th>WET Net Weight:</th>
            <td>{{parseInt(weightTicketItem.weight)}} lb</td>
          </tr>
          <tr>
            <th>DRY Net Weight:</th>
            <td>{{parseInt(weightTicketItem.dryNet)}} lb</td>
          </tr>
          <tr>
            <th>AVM Value% :</th>
            <td>{{weightTicketItem.avm}}</td>
          </tr>
          <tr>
            <th>Moisture Deduction % :</th>
            <td>{{weightTicketItem.moistureDedInPercent}}</td>
          </tr>
          <tr>
            <th>Moisture Deduction lbs :</th>
            <td>{{weightTicketItem.moistureDedInLBS}} lb</td>
          </tr>

          <tr>
            <th>OOC Bales:</th>
            <td>{{weightTicketItem.bales}}</td>
          </tr>
          <tr>
            <th>LDPE Bales:</th>
            <td>{{weightTicketItem.plasticCount}}</td>
          </tr>
          <tr>
            <th>Plastic Weight::</th>
            <td>{{weightTicketItem.plasticWeight}}</td>
          </tr>
          <tr>
            <th>Pallets:</th>
            <td>{{weightTicketItem.palletCount}}</td>
          </tr>
          <tr>
            <th>Pallet Weight:</th>
            <td>{{weightTicketItem.palletWeight}}</td>
          </tr>
          <tr>
            <th>Material</th>
            <td>{{weightTicketItem.matnr}}</td>
          </tr>
          <tr>
            <th>Driver name:</th>
            <!--<td>{{weightTicketItem.moveInBy}}</td>-->
            <td>{{weightTicketItem.fsiDriverName}}</td>
          </tr>
          <tr>
            <th>Truck LIC Plate:</th>
            <td>{{weightTicketItem.driverLP}}</td>
          </tr>
          <tr>
            <th>Trailer Number:</th>
            <td>{{weightTicketItem.containerNo}}</td>
          </tr>
          <!-- <tr>
            <th>Dispatcher:</th>
            <td>{{weightTicketItem.createdBy}}</td>
          </tr> -->
        </table>

        <table id= "signature">    
          <tr>
            <td>DRIVER NAME</td>
          </tr>
          <tr>
            <th>(PLEASE PRINT) : _______________________ </th>
            <td>GROSS BY: ________________________DEPUTY___________________________</td>
          </tr>
          <tr>
            <td>DRIVER</td>
          </tr>
          <tr>
            <th>SIGNATURE: ___________________________ </th>
            <td>TARE BY : _________________________DEPUTY___________________________</td>
         </tr>
      </table>

        <dir hight= 20px></dir>
        <h1 class = "heading2 centerPrint">{{weightTicketItem.weightmaster4}}</h1>
        <h1 class = "heading2 centerPrint">{{weightTicketItem.weightmaster5}}</h1>
        <h1 class = "heading3 centerPrint">{{weightTicketItem.weightmaster1}}</h1>
        <h1 class = "heading2">{{weightTicketItem.weightmaster2}}</h1>
        <h1 class = "heading2">{{weightTicketItem.weightmaster3}}</h1>
        <dir hight= 20px></dir>

    </WindowPortal>



    <WindowPortal v-model="transferTicketStatus">
      <button id="printf" onclick="window.print()">Print this page</button>
      <div style="height: 20px"></div>
        <h1 class = "heading1 centerPrint">{{transferTicketItem.company}}</h1>
        <dir hight= 20px></dir>
        <h1 class = "heading2 centerPrint">{{transferTicketItem.add1}}</h1>
        <h1 class = "heading2 centerPrint">{{transferTicketItem.add2}}</h1>
        <h1 class = "heading2 centerPrint">{{transferTicketItem.add3}}</h1>
        <h1 class = "heading2 centerPrint">{{transferTicketItem.add4}}</h1>
        <h1 class = "heading2 centerPrint">{{transferTicketItem.add5}}</h1>
        <h1 class = "heading2 centerPrint">{{transferTicketItem.add6}}</h1>
        <h1 class = "heading3 centerPrint">{{transferTicketItem.add7}}</h1>
        <h1 class = "heading3 centerPrint">{{transferTicketItem.add8}}</h1>
        <h1 class = "heading3 centerPrint">{{transferTicketItem.add9}}</h1>
        <h1 class = "heading3 centerPrint">{{transferTicketItem.add10}}</h1>
        <h1 class = "heading3 centerPrint">{{transferTicketItem.add11}}</h1>
        <h1 class = "heading3 centerPrint">{{transferTicketItem.add12}}</h1>
        <h1 class = "heading3 centerPrint">{{transferTicketItem.add13}}</h1>
        <!-- <dir hight= 20px></dir>
        <h1 class = "heading2 centerPrint">Transloading Ticket</h1> -->
        <dir hight= 20px></dir>
        <h1 class = "heading2 centerPrint">TRUCKER SIGNATURE:___________________________</h1>
        <dir hight= 10px></dir>
        <h1 class = "heading2 centerPrint">DRIVER NAME:_________________________________</h1>
        <dir hight= 10px></dir>
        <h1 class = "heading2 centerPrint">FORKLIFT OPERATOR:___________________________</h1>

        <div style="height: 20px"></div>
        <div class ="hContainer" >
          <div class = "item0"></div>
          <div class = "item0">Rec.Window: {{transferTicketItem.receivingWindows}}
            {{transferTicketItem.inboundShipment}}</div>
          <div class = "item0"><qrcode-vue :value="transferTicketItem.inboundShipment"/></div>
        </div>

        <div class = "container">
          <div class = "cr">Date:</div>
          <div class = "cl">{{transferTicketItem.gwDate | date}}</div>
          <div class = "cr">IBS#:</div>
          <div class = "cl">{{transferTicketItem.inboundShipment}}</div>
          <div class = "cr">PO #:</div>
          <div class = "cl">{{transferTicketItem.po}}</div>
          <div class = "cr">Supplier:</div>
          <div class = "cl">{{transferTicketItem.supplier_name}}</div>
          <div class = "cr"></div>
          <div class = "cl"></div>
          <div class = "cr">Appointment Date:</div>
          <div class = "cl">{{transferTicketItem.apptDate | date}}</div>
          <div class = "cr">Appointment Time:</div>
          <div class = "cl">{{transferTicketItem.apptTime}}</div>
          <div class = "cr">Check in time:</div>
          <div class = "cl">{{transferTicketItem.ciDate | time}}</div>
          <div class = "cr">Walk in:</div>
          <div class = "cl">{{transferTicketItem.workIn}}</div>
          <div class = "cr">Gross Weight:</div>
          <!--<div class = "cl">{{parseInt(transferTicketItem.vgmWeight)}} lb</div>-->
          <div class = "cl">{{transferTicketItem.deductedVGMWeight}} lb</div>
          <div class = "cr">Grade:</div>
          <div class = "cl">{{transferTicketItem.matnr}}</div>
          <div class = "cr"></div>
          <div class = "cl"></div>
          <div class = "cr">Bales:</div>
          <div class = "cl">________________</div>
          <div class = "cr">Upgrade Suggestion:</div>
          <div class = "cl">________________</div>
          <div class = "cr">Upgrade Bales:</div>
          <div class = "cl">________________</div>
          <div class = "cr"></div>
          <div class = "cl"></div>
          <!-- <div class = "cr">Driver Name:</div>
          <div class = "cl">{{transferTicketItem.moveInBy}}</div> -->
          <div class = "cr">Truck LIC Plate:</div>
          <div class = "cl">{{transferTicketItem.driverLP}}</div>
          <div class = "cr">Trailer Number:</div>
          <div class = "cl">{{transferTicketItem.containerNo}}</div>
      </div>
    </WindowPortal>


 
      <b-sidebar 
      type="is-light"
      :fullheight= true
      :fullwidth= false
      :overlay= false
      :right= true
      v-model="sideBar"
    >   <div style = "display: flex; justify-content:flex-end">
        <md-button class="md-icon-button md-dense" @click="hidesideBar">
        <md-icon >cancel</md-icon>
        </md-button> </div>

        <h1>Summary Scale</h1>
        <h2>Waiting for call</h2>
        <label>Normal: {{getWaitingForCallN}}</label>
        <label>Flat Bed {{getWaitingForCallF}}</label>

        <h2>Waiting for GW</h2>
        <label>Normal: {{getWaitingForGWN}}</label>
        <label>Flat Bed: {{getWaitingForGWF}}</label>

        <h2>Uploading</h2>
        <label>Normal: {{getUploadingN}}</label>
        <label>Flat Bed: {{getUploadingF}}</label>

        <h2>Open Load</h2>
        <label>Normal: {{getOpenLoadN}}</label>
        <label>Flat Bed: {{getOpenLoadF}}</label>

        <h2>TW Scaled</h2>
        <label>Normal: {{getTWScaledN}}</label>
        <label>Flat Bed: {{getTWScaledF}}</label>

        <h2>Rec Load</h2>
        <label>Normal: {{getRecLoadN}}</label>
        <label>Flat Bed: {{getRecLoadF}}</label>
    </b-sidebar>
 




    <!-- <inbound-form ref="ScaleGrossWeight" 
      mode="SWR"
      :action="setGrossWeight"/>
    <inbound-form ref="ScaleTareWeight" 
      mode="STR"
      :action="setTareWeight"/> -->


    <inbound-form ref="ScaleGrossWeight" 
      mode="SWR"
      :action="setGrossWeight"/>

    <inbound-form ref="ScaleTareWeight" 
      mode="STR"
      :action="setTareWeight"/>





    <inbound-form ref="InboundFormUpdate" 
      mode="APPTU"
      :action="updateView"/>

    <!--  
    <driver-form ref="DriverFormCreate"
      mode = "INBOUNDCREATE"
      :onCreate="loadCreateDriver" />
     -->
    <f-s-i-driver-form ref="FSIDriverFormCreate"
      mode = "CREATE"
      :onfsicreate="loadFSICreateDriver" />

    <driver-SMS-form ref="DriverSMSForm"
      mode = "SMS" />  

    <driver-SMS-form ref="DriverCallSMSForm"
      mode = "CALLSMS" />  

    <driver-SMS-form ref="DriverSMSLogForm"
      mode = "LOG" /> 

    <webCam-form ref="WebCamForm" 
      :onScan="loadBOL"
    />   


    <md-dialog class="modalC" :md-active.sync="isWarning">
      <md-dialog-content class="icons-center">
        <i class="material-icons md-48 md-light">warning</i>
        <h1 class="modalTitle">{{ this.modalMessage }}</h1>
      </md-dialog-content>
    </md-dialog>

 
    <md-card  class="searchPanel">
      <md-card-content>
        <div class="md-layout md-gutter">
          <div
            v-if="active"
            class="md-layout-item md-size-20 md-small-size-100"
          >
            <div class = "inputBox" >
              <md-field>
                <label>Transloading Yard</label>
                <md-input v-model="searchRequest.transloadingYard" disabled @keyup.enter="doSearch('0')"/>
              </md-field>
            </div>

          </div>
          <div
            v-if="active"
            class="md-layout-item md-size-20 md-small-size-100"
          >
            <!-- 2nd col -->
            <div class = "inputBoxInbound" >
              <auto-complete-master-data-select
                                                group="REC_WINDOW"
                                                label="Receiving Windows"
                                                :preparedOptions="inbound_recwin"
                                                :init-value="searchRequest.receivingWindows"
                                                :watchValueId="searchRequest.receivingWindows"
                                                :on-item-changed="handleWindowsChanged"
                                                >
            </auto-complete-master-data-select>
            </div>

            
          </div>
          <div
            v-if="active"
            class="md-layout-item md-size-20 md-small-size-100"
          >
            <!-- 3rd col -->
            <div class = "inputBoxInbound" >
              <datepicker v-model="searchRequest.apptDate">
                <label>Appointment Date</label>
              </datepicker>
            </div>
            
          </div>
          <div
            v-if="active"
            class="md-layout-item md-size-20 md-small-size-100"
          >
            <!-- 4th col -->
            <div class = "inputBoxInbound" >
              <auto-complete-master-data-select
                                                group="DOCKTYPE"
                                                label="Dock Type"
                                                :init-value="searchRequest.dockType"
                                                :on-item-changed="handleDockChanged"
                                                >
            </auto-complete-master-data-select>
           
            </div>
            
          </div>
          <div
            v-if="active"
            class="md-layout-item md-size-20 md-small-size-100"
          >
          <!-- <div class = "filterBar" @click="genrerateAppt">filter</div> -->
             <md-button
                  class="custButtonFilter md-raised"
                  @click="filterBar"
                  > 
                 Filter
                  <!-- <div class = "upperLine">Generate</div>
                  <div class = "lowerLine">Appointment</div>  -->
                  </md-button
                >
            
          </div>
          <div v-if="active">
            <div class="result-included-outter-div">

            <div class="result-included-inner-div">
               Included result: 
            </div>
            <div class="result-included-div-span">
            <span v-if="buttonshow">
             <md-checkbox v-model="checkin" @change="onChangeCheckIn"><label>Check in</label></md-checkbox> 
            </span>
            <span class="result-included-span" v-if="buttonshow"> 
                  <md-checkbox v-model="call"><label>Called</label></md-checkbox>
            </span>
            <span class="result-included-span">       
                  <md-checkbox v-model="scaleload"><label>Scaled Load</label></md-checkbox>
            </span>
            <span class="result-included-span">       
             <md-checkbox v-model="scalegross"><label>Scaled Gross</label></md-checkbox> 
            </span>
            </div>
            </div> 

            <div class="result-included-outter-div-btn1">
            <div class="result-included-inner-div-btn1">
              <!--<md-radio v-model="selectInboundLayout" value="inbound_layout_default"  @change="onSelectreport" >Default</md-radio>-->
              <!--<md-radio v-model="selectInboundLayout" value="inbound_layout_1"  @change="onSelectreport" >1</md-radio>-->
              <!--<md-radio v-model="selectInboundLayout" value="inbound_layout_2"  @change="onSelectreport" >2</md-radio>-->
              <div class = "inputBox layout-input">
                 <auto-complete-select
                        :label="layout_type"
                        :value="selectedLayout"
                        :on-item-changed="handleLayoutChanged"
                        :options="userLayoutNameList"
                    >   
                 </auto-complete-select>
              </div>
              <div class="layout-div">
                  <md-button class="custButton md-raised icon1 align-right" @click="createLayout" >Create</md-button>
                  <md-button class="custButton md-raised icon1 align-right" @click="updateLayout" >Update</md-button> 
                  <md-button class="md-raised custButton icon1 align-right" @click="doReloadLayout">Reload</md-button>
                  <md-button class="custButton md-raised icon1 align-right" @click="loadLayout" >Load</md-button>
              </div>
            </div>
          </div> 

          </div>
          <div
            v-if="getPermission.opcockpiti.edit"
            class="md-layout-item md-size-100 md-small-size-100"
          >
            <callingApiCenter
              :paths="[
                '/api/w/fsi/WebSearchInbound',
                '/api/w/fsi/WebGenerateInbound',
                '/api/w/layout/Search'
              ]"
            >
              <callingApiCenter
                path="/api/w/fsi/WebSaveInbound"
                :not-display-error="true"
              >
              <b-notification class = "notifySize"
                  type="is-success"
                  v-model="notifyActive"
                  aria-close-label="Close notification">
                  {{notifyMessage}}
                </b-notification>


<!-- genrerateAppt -->
                <md-button v-if="buttonshow"
                  class="custButtonInbound md-raised"
                  @click="genrerateAppt"
                  :disabled="this.getPermission.fsireadonly.view || this.getPermission.fsireadonlyforerl.view || this.getPermission.fsireadonlywithwgtticket.view || this.getPermission.stcoptfsireadonly.view || processAppt"
                  > 
                  <DoubleLine
                  field1="Generate"
                  field2="Appointment"
                  ></DoubleLine>
                  <!-- <div class = "upperLine">Generate</div>
                  <div class = "lowerLine">Appointment</div>  -->
                  </md-button
                >

                <md-button v-if="buttonshow"
                  class="custButtonInbound md-raised"
                  @click="updateAppt"
                  :disabled="this.getPermission.fsireadonly.view || this.getPermission.fsireadonlyforerl.view || this.getPermission.fsireadonlywithwgtticket.view || this.getPermission.stcoptfsireadonly.view"
                  >
                  
                  <DoubleLine
                  field1="Update"
                  field2="Appointment"
                  ></DoubleLine>
                  </md-button
                >

                <md-button v-if="buttonshow"
                  class="custButtonInbound md-raised"
                  @click="walkInAppt"
                  :disabled="this.getPermission.fsireadonly.view || this.getPermission.fsireadonlyforerl.view || this.getPermission.fsireadonlywithwgtticket.view || this.getPermission.stcoptfsireadonly.view"
                  >
                  
                  <DoubleLine
                  field1="Walk In"
                  field2="Appointment"
                  ></DoubleLine>
                  </md-button
                >


                <md-button
                  
                  class="custButtonInbound md-raised"
                  @click="doSave"
                  :disabled="!getSaveCond || this.getPermission.fsireadonly.view || this.getPermission.fsireadonlyforerl.view || this.getPermission.fsireadonlywithwgtticket.view || this.getPermission.stcoptfsireadonly.view"
                  > 
                  
                  Save
                  </md-button
                >

                <md-button v-if="buttonshow"
                  
                  class="custButtonInbound md-raised"
                  @click="checkInAppt"
                  :disabled="this.getPermission.fsireadonly.view || this.getPermission.fsireadonlyforerl.view || this.getPermission.fsireadonlywithwgtticket.view || this.getPermission.stcoptfsireadonly.view"
                  > 
                  Check In
                  </md-button
                >

                <md-button v-if="buttonshow"
                  
                  class="custButtonInbound md-raised"
                  @click="bolAppt"
                  :disabled="this.getPermission.fsireadonly.view || this.getPermission.fsireadonlyforerl.view || this.getPermission.fsireadonlywithwgtticket.view || this.getPermission.stcoptfsireadonly.view"
                  > 
                  BOL Input
                  </md-button
                >

                <md-button v-if="buttonshow"
                 
                  class="custButtonInbound md-raised"
                  @click="scaleCallAppt"
                  :disabled="this.getPermission.fsireadonly.view || this.getPermission.fsireadonlyforerl.view || this.getPermission.fsireadonlywithwgtticket.view || this.getPermission.stcoptfsireadonly.view"
                  > 
                  Scale Call
                  </md-button
                >

                <md-button v-if="buttonshow"
                  :disabled="(!getPrintCond && this.isdisableSend) || this.getPermission.fsireadonly.view || this.getPermission.fsireadonlyforerl.view || this.getPermission.fsireadonlywithwgtticket.view || this.getPermission.stcoptfsireadonly.view"
                  class="custButtonInbound md-raised"
                  @click="sendSMS"
                  > 
                  SMS
                </md-button>

                <md-button v-if="buttonshow"
                  :disabled="(!getPrintCond && this.isdisableSend) || this.getPermission.fsireadonly.view || this.getPermission.fsireadonlyforerl.view || this.getPermission.fsireadonlywithwgtticket.view || this.getPermission.stcoptfsireadonly.view"
                  class="custButtonInbound md-raised"
                  @click="smsLog"
                  > 
                  SMS Log
                </md-button>

                <md-button v-if="buttonshow"
                  :disabled="this.isdisablephoto || this.getPermission.fsireadonly.view || this.getPermission.fsireadonlyforerl.view || this.getPermission.fsireadonlywithwgtticket.view || this.getPermission.stcoptfsireadonly.view"
                  @click="takeBOLPic"
                  class="custButtonInbound md-raised"
                  > 
                  <DoubleLine
                    field1="BOL"
                    field2="Capture"
                  ></DoubleLine>
                </md-button>

                <md-button
                  
                  class="custButtonInbound md-raised"
                  @click="ticketManagement"
                  :disabled="!getTicketManagement || this.getPermission.fsireadonly.view || this.getPermission.fsireadonlyforerl.view || this.getPermission.fsireadonlywithwgtticket.getInitView || this.getPermission.stcoptfsireadonly.view"
                  > 
                  <DoubleLine
                  field1="Ticket"
                  field2="Management"
                  ></DoubleLine>
                  </md-button
                >


                <md-button
                  
                  class="custButtonInbound md-raised"
                  @click="scaleGW"
                  :disabled="this.getPermission.fsireadonly.view || this.getPermission.fsireadonlyforerl.view || this.getPermission.fsireadonlywithwgtticket.view || this.getPermission.stcoptfsireadonly.view"
                  > 
                  <DoubleLine
                  field1="Scale"
                  field2="Gross Weight"
                  ></DoubleLine>
                  </md-button
                >

                <md-button
                  
                  class="custButtonInbound md-raised"
                  @click="transferTicket"
                  :disabled="!getPrintCond || this.getPermission.fsireadonly.view || this.getPermission.fsireadonlyforerl.view || this.getPermission.fsireadonlywithwgtticket.view || this.getPermission.stcoptfsireadonly.view"
                  > 
                  <DoubleLine
                  field1="Print"
                  field2="Transfer Ticket"
                  ></DoubleLine>
                  </md-button
                >

                <md-button
                  
                  class="custButtonInbound md-raised"
                   @click="scaleTW"
                   :disabled="this.getPermission.fsireadonly.view || this.getPermission.fsireadonlyforerl.view || this.getPermission.fsireadonlywithwgtticket.view || this.getPermission.stcoptfsireadonly.view"
                  > 
                  <DoubleLine
                  field1="Scale"
                  field2="Tare Weight"
                  ></DoubleLine> 
                  </md-button
                >

                <md-button
                  
                  class="custButtonInbound md-raised"
                  @click="weightTicket"
                  :disabled="!getPrintCond || this.getPermission.fsireadonly.view || this.getPermission.stcoptfsireadonly.view"
                  > 
                  <DoubleLine
                  field1="Print"
                  field2="Weight Ticket"
                  ></DoubleLine> 
                  </md-button
                >

                <md-button
                  
                  class="custButtonInbound md-raised"
                  @click="inboundRemark"
                  :disabled="this.getPermission.fsireadonly.view || this.getPermission.fsireadonlywithwgtticket.view || this.getPermission.stcoptfsireadonly.view || noRemark()"
                  > 
                  Remark
                  </md-button
                >

                <md-button
                  id="searchTag"
                  @click="doSearch('0')"
                  class="custButtonInbound md-primary md-raised"
                  >Search</md-button
                >
                <md-button @click="clearSearch" class="md-raised custButtonInbound"
                  >Clear</md-button
                >

                <md-button
                  
                class="custButtonInbound md-raised"
                @click="doDownloadExcel"
                :disabled="!getDownloadCond"
                > 
                Download
                </md-button
              >

                <input
                  class="custSearchBar"
                  type="text"
                  placeholder="Searching Term"
                  v-model="filter"
                />

                <md-button
                  
                  class="custButtonInbound md-raised"
                  @click="getScaleWeight"
                  v-if="getScaledCond"
                  > 
                  Scaling
                  </md-button
                >


                <md-button
                  
                  class="custButtonInbound md-raised"
                  @click="getSummary"
                  v-if="getSummaryCond"
                  > 
                  Summary
                  </md-button
                >
              
                

                <md-button
                  class="md-icon-button"
                  @click="mouseLeave"
                  id="expand-button"
                >

                


                  <md-icon v-if="active == false">keyboard_arrow_down</md-icon>
                  <md-icon v-if="active == true">keyboard_arrow_up</md-icon>
                </md-button>
              </callingApiCenter>
            </callingApiCenter>
          </div>
        </div>
      </md-card-content>
    </md-card>
    <pagination :items="filteredRows">
      <template slot-scope="{ pageItems }">
        <md-card class="data-table-container">
          <div  class="outer-container">
            <div  class="inner-container">
              <div class="table-header">

                 <!--  new implementation -->
                 <table id="headertable">
                   <thead>
                     <tr class="table-container">
                      <th class="header-cell w2 fix"></th>
                      <th v-for="(value, key) in loaded_user_layout" :key="key"
                          class="header-cell center table-container-th" 
                          v-bind:class="{ w2: value.colWidth == '2', w3: value.colWidth == '3', w4: value.colWidth == '4', 
                                          w5: value.colWidth == '5', w7: value.colWidth == '7', w8: value.colWidth == '8',
                                          w10: value.colWidth == '10', w15: value.colWidth == '15'}"
                          v-on:click="sortFunction(value.colDataElement)"
                      >
                       {{ value.colHeaderText }}
                      </th>  

                    </tr>
                  </thead>
                </table>

                <!--
                <table id="headertable">
                  <thead>
                    <tr >
                      <th class="header-cell w2 fix"></th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['errorMsg']">
                        Error Message
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['transloadingYard']"
                        v-on:click="sortFunction('transloadingYard')">
                        Transloading Yard
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['receivingWindows']"
                        v-on:click="sortFunction('receivingWindows')">
                        Receiving Windows
                      </th>
                      <th
                        class="header-cell center w4"
                        v-if="viewFilter['dockType']"
                        v-on:click="sortFunction('dockType')">
                        Dock Type
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['apptNo']"
                        v-on:click="sortFunction('apptNo')">
                        Appointment No.
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['apptDate']"
                        v-on:click="sortFunction('apptDate')">
                        Appointment Date
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['apptTime']"
                        v-on:click="sortFunction('apptDate')">
                        Appointment Time
                      </th>
                      <th
                        class="header-cell center w8"
                        v-if="viewFilter['inboundShipment']"
                        v-on:click="sortFunction('inboundShipment')">
                        Inbound Shipment
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['matnr']"
                        v-on:click="sortFunction('matnr')">
                        Material
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['matnr_desc']"
                        v-on:click="sortFunction('matnr_desc')">
                        Material Desc
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['salesOffice']"
                        v-on:click="sortFunction('salesOffice')">
                        Inbound Type
                      </th>
                      <th
                        class="header-cell center w3"
                        v-if="viewFilter['block']"
                        v-on:click="sortFunction('block')">
                        Block
                      </th>
                      <th
                        class="header-cell center w3"
                        v-if="viewFilter['inboundStatusO']"
                        v-on:click="sortFunction('inboundStatus')">
                        Open
                      </th>
                      <th
                        class="header-cell center w4"
                        v-if="viewFilter['inboundStatusC']"
                        v-on:click="sortFunction('inboundStatus')">
                        Check In
                      </th>
                      <th
                        class="header-cell center w3"
                        v-if="viewFilter['inboundStatusR']"
                        v-on:click="sortFunction('inboundStatus')">
                        Received
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['inboundStatusN']"
                        v-on:click="sortFunction('inboundStatus')">
                        No Show
                      </th>

                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['inboundStatusL']"
                        v-on:click="sortFunction('inboundStatus')">
                        Driver Left
                      </th>


                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['workIn']"
                        v-on:click="sortFunction('workIn')">
                        Work In
                      </th>
                      
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['salesOffice']"
                        v-on:click="sortFunction('salesOffice')">
                        Trucker Name
                      </th>
                      <th
                        class="header-cell center w8"
                        v-if="viewFilter['externalTrucker']"
                        v-on:click="sortFunction('externalTrucker')">
                        External Trucker
                      </th>
                      <th
                        class="header-cell center w15"
                        v-if="viewFilter['moveInBy']"
                        v-on:click="sortFunction('moveInBy')">
                        Driver / Driver Phone number
                      </th>
                    -->
                      <!--
                      <th
                        class="header-cell center w8"
                        v-if="viewFilter['driverPh']"
                        v-on:click="sortFunction('driverPh')">
                        Driver Phone Number
                      </th>
                    -->
                      <!--
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['driverLP']"
                        v-on:click="sortFunction('driverLP')">
                        License Plate#
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['containerNo']"
                        v-on:click="sortFunction('containerNo')">
                        Trailer#
                      </th>
                      
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['ciDate']"
                        v-on:click="sortFunction('ciDate')">
                        CI Date
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['ciDate']"
                        v-on:click="sortFunction('ciDate')">
                        CI Time
                      </th>
                      <th
                        class="header-cell center w5"
                         v-if="viewFilter['scaleCalled']"
                        v-on:click="sortFunction('scaleCalled')">
                        Scale Called
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['callTime']"
                        v-on:click="sortFunction('callTime')">
                        Call Time
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['gwStation']"
                        v-on:click="sortFunction('gwStation')">
                        GW Station
                      </th>
                      <th
                        class="header-cell center w7"
                        v-if="viewFilter['scaleTicket']"
                        v-on:click="sortFunction('scaleTicket')">
                        Weight Ticket
                      </th>
                      <th
                        class="header-cell center w7"
                        v-if="viewFilter['scaleTicket']"
                        v-on:click="sortFunction('scanWt')">
                        Scan Weight Ticket
                      </th>
                      <th
                        class="header-cell center w7"
                        v-if="viewFilter['scaleTicket']"
                        v-on:click="sortFunction('scanWt')">
                        Ticket To SAP
                      </th>

                      <th
                        class="header-cell center w7"
                        v-if="viewFilter['scaleTicket']"
                        v-on:click="sortFunction('scanWt')">
                        Scan WT Image
                      </th>

                      

                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['vgmWeight']"
                        v-on:click="sortFunction('vgmWeight')">
                        Gross Weight
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['gwDate']"
                        v-on:click="sortFunction('gwDate')">
                        GW Date
                      </th>

                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['gwDate']"
                        v-on:click="sortFunction('gwDate')">
                        GW Time
                      </th>

                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['gwDate']"
                        v-on:click="sortFunction('gwDate')">
                        GW Time Web
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['originalGW']"
                        v-on:click="sortFunction('originalGW')">
                        GW by user
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['gwYgNo']"
                        v-on:click="sortFunction('gwYgNo')">
                        GW-YG No.
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['gwYgWeight']"
                        v-on:click="sortFunction('gwYgWeight')">
                        GW-YG Weight
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['twStation']"
                        v-on:click="sortFunction('twStation')">
                        TW Station
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['tareWeight']"
                        v-on:click="sortFunction('tareWeight')">
                        Tare Weight
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['twDate']"
                        v-on:click="sortFunction('twDate')">
                        TW Date
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['twDate']"
                        v-on:click="sortFunction('twDate')">
                        TW Time
                      </th>

                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['twDate']"
                        v-on:click="sortFunction('twDate')">
                        TW Time Web
                      </th>

                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['originalTW']"
                        v-on:click="sortFunction('originalTW')">
                        TW by user
                      </th>

                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['weight']"
                        v-on:click="sortFunction('weight')">
                        Net Weight
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['avm']"
                        v-on:click="sortFunction('avm')">
                        AVM
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['moistureDedInLBS']"
                        v-on:click="sortFunction('moistureDedInLBS')">
                        Moisture Deduct (LBS)
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['moistureDedInPercent']"
                        v-on:click="sortFunction('moistureDedInPercent')">
                        Moisture Deduct (%)
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['wetNet']"
                        v-on:click="sortFunction('wetNet')">
                        Wet Net
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['dryNet']"
                        v-on:click="sortFunction('dryNet')">
                        Dry Net
                      </th>

                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['totalHours']"
                        v-on:click="sortFunction('totalHours')">
                        Waiting Time
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['twYgNo']"
                        v-on:click="sortFunction('twYgNo')">
                        TW-YG No.
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['twYgWeight']"
                        v-on:click="sortFunction('twYgWeight')">
                        TW-YG Weight
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['plasticCount']"
                        v-on:click="sortFunction('plasticCount')">
                        Plastic Count
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['palletCount']"
                        v-on:click="sortFunction('palletCount')">
                        Pallet Count
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['plasticWeight']"
                        v-on:click="sortFunction('plasticWeight')">
                        Plastic Weight
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['palletWeight']"
                        v-on:click="sortFunction('palletWeight')">
                        Pallet Weight
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['bol']"
                        v-on:click="sortFunction('bol')">
                        BOL
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['bolWT']"
                        v-on:click="sortFunction('bolWT')">
                        BOL Weight Ticket
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['bolScan']"
                        v-on:click="sortFunction('bolScan')">
                        BOL Scan
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['bolGW']"
                        v-on:click="sortFunction('bolGW')">
                        BOL Gross Weight
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['bolTW']"
                        v-on:click="sortFunction('bolTW')">
                        BOL Tare Weight
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['bolNW']"
                        v-on:click="sortFunction('bolNW')">
                        BOL Net Weight
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['weightDifferent']"
                        v-on:click="sortFunction('weightDifferent')">
                        Weight Different
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['bales']"
                        v-on:click="sortFunction('bales')">
                        Bale Count
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['looseCount']"
                        v-on:click="sortFunction('looseCount')">
                        Loose Count
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['qcIssue']"
                        v-on:click="sortFunction('qcIssue')">
                        QC Issue
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['moisture']"
                        v-on:click="sortFunction('moisture')">
                        Moisture
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['upgradeSuggestion']"
                        v-on:click="sortFunction('upgradeSuggestion')">
                        Upgrade Suggestion
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['upgradeSuggestion']"
                        v-on:click="sortFunction('upgradeBales')">
                        Upgrade Bales
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['loadRemark']"
                        v-on:click="sortFunction('loadRemark')">
                        Remark
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['ibs_type']"
                        v-on:click="sortFunction('ibs_type')">
                        Inbound type
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['route']"
                        v-on:click="sortFunction('route')">
                        Route
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['route_desc']"
                        v-on:click="sortFunction('route_desc')">
                        Route Desc
                      </th>
                      <th
                        class="header-cell center w7"
                        v-if="viewFilter['trucker_name']"
                        v-on:click="sortFunction('trucker_name')">
                        Trucker Name
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['supplier']"
                        v-on:click="sortFunction('supplier')">
                        Supplier
                      </th>
                      <th
                        class="header-cell center w10"
                        v-if="viewFilter['supplier_name']"
                        v-on:click="sortFunction('supplier_name')">
                        Supplier Name
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['inco1']"
                        v-on:click="sortFunction('inco1')">
                        Incoterms
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['po']"
                        v-on:click="sortFunction('po')">
                        PO Number
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['po_lsd']"
                        v-on:click="sortFunction('po_lsd')">
                        PO LSD
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['ac_name']"
                        v-on:click="sortFunction('ac_name')">
                        AC
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['buyer_name']"
                        v-on:click="sortFunction('buyer_name')">
                        Buyer
                      </th>
                      <th
                        class="header-cell center w3"
                        v-if="viewFilter['sapStatus']"
                        v-on:click="sortFunction('sapStatus')">
                        SAP Status
                      </th>

                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['unloadInfo']"
                        >
                        Load Start Date
                      </th>

                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['unloadInfo']"
                        >
                        Load Start Time
                      </th>

                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['unloadInfo']"
                       >
                        Load End Date
                      </th>

                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['unloadInfo']"
                       >
                        Load End Time
                      </th>

                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['unloadInfo']"
                       >
                        Load User
                      </th>                     
                      
                    </tr>
                  </thead>
                </table>
              -->

              </div>
              <div id = 'tableId' class="table-body" @scroll="handleScroll">
                <table id="bodytable">
                  <tbody>
                    <tr :key="item.apptNo" class="" v-for="item in pageItems">
                        <td class="body-cell w2 fix" style="left: 0px">
                           <md-checkbox v-model="item.selected">
                              <span v-if="hasBeenChanged(item)">*</span>
                           </md-checkbox>
                        </td>

                        <td v-for="(value,key) in loaded_user_layout" :key="key"
                              class="body-cell excelBox"
                              v-bind:class="{ w2: value.colWidth == '2', w3: value.colWidth == '3', w4: value.colWidth == '4', 
                                          w5: value.colWidth == '5', w7: value.colWidth == '7', w8: value.colWidth == '8',
                                          w10: value.colWidth == '10', w15: value.colWidth == '15', 
                                          warnError: (value.colDataElement == 'tareWeight' && overTWMinMax(item)) || (value.colDataElement == 'vgmWeight' && overGWMinMax(item)) || (value.colDataElement == 'weight' && overNWMinMax(item))}"
 
                        >
                           <template v-if="value.colDataElement == 'inboundStatus' && value.colDataType == 'STATUS_OPEN'">
                              <template v-if="item[value.colDataElement] == 'O'">
                                  X
                              </template>
                              <template v-else>
                                 <template v-if="item[value.colDataElement] == 'C'">
                                    O
                                 </template>
                              </template>
                           </template> 

                           <template v-if="value.colDataElement == 'inboundStatus' && value.colDataType == 'STATUS_CHECKIN'">
                              <template v-if="item[value.colDataElement] == 'C'">
                                  X
                              </template>
                           </template> 

                           <template v-if="value.colDataElement == 'inboundStatus' && value.colDataType == 'STATUS_REC'">
                              <template v-if="item[value.colDataElement] == 'R'">
                                  X
                              </template>
                           </template> 

                           <template v-if="value.colDataElement == 'inboundStatus' && value.colDataType == 'STATUS_NOSHOW'">
                              <template v-if="item[value.colDataElement] == 'N'">
                                  X
                              </template>
                           </template> 

                           <template v-if="value.colDataElement == 'inboundStatus' && value.colDataType == 'STATUS_DRIVERLEFT'">
                              <template v-if="item[value.colDataElement] == 'L'">
                                  X
                              </template>
                           </template> 
                           
                           <template v-if="value.colDataElement == 'containerNo'">
                             <template v-if="edit.containerNo && ( item.sapStatus == null || item.sapStatus != 'X') ">
                                <md-field>
                                  <md-input v-model="item.containerNo"/> 
                                </md-field> 
                             </template>
                             <template v-else>
                                {{ item[value.colDataElement] }}
                             </template>
                           </template>
                           <template v-if="value.colDataType == 'DATE' || value.colDataType == 'TIME'">
                              <template v-if="value.colDataType == 'DATE'">
                                 {{ item[value.colDataElement] | date }}
                              </template>
                              <template v-if="value.colDataType == 'TIME'">
                                 {{ item[value.colDataElement] | time }}
                              </template>
                           </template>
                           <template v-if="value.colDataElement == 'totalHours'">
                               <template v-if="edit.totalHours && ((item.sapStatus == null || item.sapStatus != 'X'))">
                                   <md-field>
                                      <md-input v-model="item[value.colDataElement]"/>
                                   </md-field> 
                               </template>
                               <template v-else>
                                   {{ item[value.colDataElement] }}
                               </template> 
                           </template>
                           <template v-if="value.colDataElement == 'plasticCount'">
                               <template v-if="edit.plasticCount && ((item.sapStatus == null || item.sapStatus != 'X'))">
                                   <md-field>
                                      <md-input v-model="item[value.colDataElement]" @keydown="numberOnly"/>
                                   </md-field> 
                                   <div class="md-error errorMessage" v-if="item.plCtError">{{ item.plCtError }}</div>
                               </template>
                               <template v-else>
                                   {{ item[value.colDataElement] }}
                               </template> 
                           </template>
                           <template v-if="value.colDataElement == 'palletCount'">
                               <template v-if="edit.palletCount && ((item.sapStatus == null || item.sapStatus != 'X'))">
                                   <md-field>
                                      <md-input v-model="item[value.colDataElement]" @keyup="doCalPalletWgt(item)"/>
                                   </md-field> 
                                   <div class="md-error errorMessage" v-if="item.paCtError">{{ item.paCtError }}</div>
                               </template>
                               <template v-else>
                                   {{ item[value.colDataElement] }}
                               </template> 
                           </template>
                           <template v-if="value.colDataElement == 'plasticWeight'">
                               <template v-if="edit.plasticWeight && ((item.sapStatus == null || item.sapStatus != 'X'))">
                                   <md-field>
                                      <md-input v-model="item[value.colDataElement]" @keydown="decOnly"/>
                                   </md-field> 
                                   <div class="md-error errorMessage" v-if="item.plWeError">{{ item.plWeError }}</div>
                               </template>
                               <template v-else>
                                   {{ item[value.colDataElement] }}
                               </template> 
                           </template>
                           <template v-if="value.colDataElement == 'weightDifferent'">
                               <template v-if="edit.weightDifferent && ((item.sapStatus == null || item.sapStatus != 'X'))">
                                   <md-field>
                                      <md-input v-model="item[value.colDataElement]"/>
                                   </md-field> 
                               </template>
                               <template v-else>
                                   {{ item[value.colDataElement] }}
                               </template> 
                           </template>
                           <template v-if="value.colDataElement == 'loadRemark'">
                               <template v-if="edit.loadRemark && ((item.sapStatus == null || item.sapStatus != 'X'))">
                                   <md-field>
                                      <md-input v-model="item[value.colDataElement]"/>
                                   </md-field> 
                               </template>
                               <template v-else>
                                   {{ item[value.colDataElement] }}
                               </template> 
                           </template>
                           <template v-if="value.colDataElement == 'tareWeight' || value.colDataElement == 'vgmWeight'">
                               <template v-if="item[value.colDataElement] == null">
                                  {{ item[value.colDataElement] }}
                               </template>
                               <template v-else>
                                  {{parseInt(item[value.colDataElement])}}
                               </template>
                           </template>
                           <template v-if="value.colDataElement == 'originalTW'">
                               <template v-if="item[value.colDataElement] != null && item[value.colDataElement] != '' && parseInt(item.tareWeight) != parseInt(item[value.colDataElement])">
                                   X
                               </template>
                           </template>
                           <template v-if="value.colDataElement == 'originalGW'">
                               <template v-if="item[value.colDataElement] != null && item[value.colDataElement] != '' && parseInt(item.vgmWeight) != parseInt(item[value.colDataElement])">
                                   X
                               </template>                                
                           </template>
                           <template v-if="value.colDataElement == 'scanWtLink'">
                               <template v-if="item[value.colDataElement] != null">
                                  <a href="" @click.prevent="getPhotos(item)">1 photos</a>
                               </template>
                               <template v-else>
                                  <span>0 photo</span>
                               </template> 
                           </template>
                           <template v-if="value.colDataElement == 'ticketSAP'">
                               {{ getWtForSAP(item) }}
                           </template> 
                           <template v-if="value.colDataElement != 'inboundStatus' && 
                                           value.colDataElement != 'containerNo' && value.colDataElement != 'plasticCount' && value.colDataElement != 'palletCount' &&
                                           value.colDataElement != 'totalHours' && value.colDataElement != 'originalGW' && value.colDataType != 'DATE' && value.colDataType != 'TIME' &&
                                           value.colDataElement != 'plasticWeight' && value.colDataElement != 'weightDifferent' &&
                                           value.colDataElement != 'loadRemark' && value.colDataElement != 'tareWeight' && value.colDataElement != 'vgmWeight' &&
                                           value.colDataElement != 'originalTW' && value.colDataElement != 'originalGW' && value.colDataElement != 'scanWtLink' &&
                                           value.colDataElement != 'ticketSAP'
                                           ">
                                 {{ item[value.colDataElement] }}
                           </template>


                           <!--
                           <template v-if="value.colDataType == 'DATE'">
                             {{ item[value.colDataElement] | date }}
                           </template>
                           <template v-else>
                              <template v-if="value.colDataType == 'TIME'">
                                {{ item[value.colDataElement] | time }}  
                              </template>
                              <template v-else>
                                <template v-if="value.colDataElement != 'inboundStatus' && value.colDataElement != 'containerNo'">
                                    {{ item[value.colDataElement] }} 
                                </template>
                              </template>
                           </template>
                          -->
                        </td>   
                     </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </md-card>
      </template>
    </pagination>
    
  </div>
</template>


<style scoped lang="scss">
@import '../../public/chris.css';
@media print {
  #printf {
    display: none; 
  }
}
    .loadingInput {
      margin: 0 !important;
      padding: 2px !important;
      vertical-align:top;
    }
    .errorMessage {
      color: #f14668;
      text-align: left;
      padding-left: 5px;
    }
    .warningMessage {
      color: #32997f;
      text-align: left;
      padding-left: 5px;
    }
    .fix {
    left: 0;
    position: -webkit-sticky;
    position: sticky;
    background: white;
    /*background-color: #5b69aa;*/
    }
    .sidebar{
      margin-top: 500px;
    }
    
 .material-icons.md-18 {
    font-size: 18px;
  }
  .material-icons.md-24 {
    font-size: 24px;
  }
  .material-icons.md-36 {
    font-size: 36px;
  }
  .material-icons.md-48 {
    font-size: 100px;
  }
  .material-icons.md-light {
    color: rgba(255, 255, 255, 1);
  }
  .material-icons.md-light.md-inactive {
    color: rgba(255, 255, 255, 0.3);
  }
tr:nth-child(2n) .fix {
    background: #DCE6F0;
  }
.container {
  display: grid;
  grid-template-columns: 200px 450px;
  margin-top: 20px;
  margin-left: 20px;
  width: 90%;
  background-color:white;
  font-size: 15px;
  
}
.cl {
    text-align: left;
    // padding-left: 10px;
    height: 20px;
}
.cr {
    text-align: left;
    height: 20px;
}

.hContainer {
  display: flex;
  flex-direction: row;
  // background-color:grey;
}

.hContainer div {
  margin: 2px;
  width: 250px;
  text-align: center;
  line-height: 28px;
  font-size: 20px;
  // background-color:lightpink;
}

#inboundData {
  width:70%;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 15px;
  height: 70px;
  margin-top: 10px;
  margin-left: 150px;
}
#inboundData th{
  text-align: left;
}
#inboundData td{
  padding-left: 10px;
}

#signature {
  width:90%;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 10px;
  height: 70px;
  margin-top: 30px;
  margin-left: 50px;
}
#signature th{
  font-family: Arial;
  text-align: left;

}
#signature td{
  // padding: 10px;
  font-family: Arial;
  text-align: left;
}
.wtheading1 {
    padding-top: 28px;
    padding-left: 0px;
    margin-bottom: 0;
    color: black;
    width: 100%;
     /* line-height: 3; */
    font-size: 38px;
    font-family: Roboto Slab;
    margin: 0;
  }
.wtheading2 {
    padding-top: 0px;
    padding-left: 0px;
    margin-bottom: 0;
    color: black;
    width: 100%;
    font-size: 20px;
    font-family: Roboto Slab;
    margin: 0;
  }

  .heading1 {
    padding-top: 30px;
    padding-left: 0px;
    margin-bottom: 0;
    color: black;
    width: 100%;
     /* line-height: 3; */
    font-size: 16px;
    font-family: Roboto Slab;
    margin: 0;
  }
.heading2 {
    padding-top: 0px;
    padding-left: 0px;
    margin-bottom: 0;
    color: black;
    width: 100%;
    font-size: 12px;
    font-weight:200;
    font-family: Roboto Slab;
    margin: 0;
  }
  
.heading3 {
    padding-top: 0px;
    padding-left: 0px;
    margin-bottom: 0;
    color: black;
    width: 100%;
    font-size: 13px;
    font-weight: bold;
    font-family: Roboto Slab;
    margin: 0;
  }
.centerPrint {
  margin: 1;
  width: 100%;
  padding: 1px;
  text-align: center;
}
.wtcenterPrint {
  margin: 1;
  width: 100%;
  padding: 10px;
  text-align: center;
}
.sameLine {
    display: inline-block !important;
}
.layout1 {
    padding-bottom: 1px;
    width: 92%;
    line-height: 1.5;
    color: #555555;
    font-family: Roboto Slab;
    margin: auto;
  }
.layoutHalf1{
      display:inline-block;
      padding-top: 7px;
      padding-bottom: 7px;
      width: 50%;
      line-height: 1.5;
      color: #555555;
      font-family: Roboto Slab;
      margin: auto;
      padding-left: 15px;
  }
  .custButtonInbound {
    margin: 10px;
    width: 80px ;
    height: 30px ;
    line-height: 20px ;
    font-size: 0.7rem ;
  }
.custButtonFilter {
    margin: 10px;
    width: 120px ;
    height: 50px ;
    line-height: 20px ;
    font-size: 0.8rem ;
  }
.inputBoxSpace {
    border: 1px solid #cacbcc;
    border-radius: 5px;
    color: #29303b;
    font-size: 18px;
    height: auto;
    width: 200px;
    line-height: 1em;
    padding: 5px 5px 5px 5px;
    margin-top: 6px;
  }
.inputBoxDouble {
    /* border: 1px solid #cacbcc;
    border-radius: 5px;
    color: #29303b;
    font-size: 18px;
    height: auto;
    line-height: 1em;
    padding: 5px 5px 5px 5px;
    margin-top: 6px; */
    width: 400px;
    justify-content: space-around;
    display: flex;
  flex-direction: row;
  }
  .inputBoxInbound {
    border: 1px solid #cacbcc;
    border-radius: 5px;
    color: #29303b;
    font-size: 12px;
    height: auto;
    line-height: 1em;
    padding: 5px 5px 5px 5px;
    margin-top: 6px;
  }
  
  .inputBoxInbound:hover {
    border: 2px solid #448aff;
    border-radius: 5px;
    color: #29303b;
    font-size: 12px;
    height: auto;
    line-height: 1em;
    padding: 5px 5px 5px 5px;
    margin-top: 6px;
    background-color: #e0eff7;
  }
.cl .md-field{
    display: inline-block !important;
    width: auto;
    margin-bottom: 10px;
    padding-top:10px;
}
.cl .md-field .md-input {
    font-size: 14px !important;
}
.selected.selected {
    background: #ffbb74eb;
  }
.icon1 {
    float: right;
    margin: 5px;
}
.result-included-outter-div {
    border: 1px solid #D0D0D0;
    border-radius: 5px;
    width: 420px;
    padding: 10px;
    height: 43px;
    margin-top: 5px;
    margin-bottom: 5px;
    margin-left: 20px;
}
.result-included-inner-div {
    margin-left: 5px;
    font-weight: bold;
    margin-bottom: -25px;
}
.result-included-div-span {
    margin-left: 120px; 
    margin-top: -10px;
}
.result-included-span {
    margin-left: 5px;
}

.result-included-outter-div-btn1 {
    border: 1px solid #D0D0D0;
    background-color: rgba(161, 103, 103, 0.3);
    border-radius: 5px;
    width: 760px;
    padding: 0px;
    height: 70px;
    margin-top: -50px;
    margin-bottom: 5px;
    margin-left: 460px;
}
.result-included-inner-div-btn1 {
    margin-left: 5px;
    margin-top: 10px;
    margin-bottom: 0px;
}

.align-right {
    float: right;
}
.layout-input {
    width: 280px;
    margin-top: -5px;
}
.layout-div {
    margin-top:-60px; 
    margin-left: 80px;
    padding: 2px;
}

.custButton {
margin: 5px;
width: 120px;
height: 40px;
line-height:40px;
font-size: 0.8rem;

}

.inputBox {
border: 1px solid #cacbcc;
border-radius: 5px;
color: #29303b;
font-size: 18px;
height: auto;
line-height: 1.5em;
padding: 5px 5px 5px 5px;
margin-top: 5px;
}

.inputBox:hover {

border: 2px solid #448aff;
border-radius: 5px;
color: #29303b;
font-size: 18px;
height: auto;
line-height: 1.5em;
padding: 6px 6px 6px 6px;
margin-top: 5px;
background-color: #e0eff7;
  
}

.warnError {
  color: red;
}

.table-container {
    background-color: #5b69aa;
}
.table-container-th {
    color: white !important;
    padding-top: 3px;
}

</style>

<script>
/* eslint-disable no-plusplus */
import { mapGetters } from "vuex";
import sort from "fast-sort";
import dateFormat from "../utils/dateFormat";
//import api from "../api";
import { newAPIPost } from '../api/index.js';
import parseXls from "../utils/parseXls";
import callingApiCenter from "../components/CallingApiCenter.vue";
//import DriverForm from '../components/DriverForm.vue';
import FSIDriverForm from '../components/FSIDriverForm.vue';
import InboundForm from '../components/InboundScale';
import DoubleLine from '../components/DoubleLine.vue';
import moment from 'moment';
import WindowPortal from '../components/WindowPortal.vue';
import WindowPortalQ from '../components/WindowPortal.vue';
import TransferTk from '../components/TransferTk.vue';
import BolPhotoForm from "../components/BolPhotoForm.vue";
import BolPhotoZoomForm from "../components/BolPhotoZoomForm.vue";
import DriverSMSForm from "../components/DriverSMSForm.vue";
import WebCamForm from "../components/WebCamForm.vue";
import toGenerateExcelRequest, { downloadExcel } from "../utils/excel";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import QrcodeVue from 'qrcode.vue';
import TicketManagement from '../components/TicketManagement.vue';
import WalkInForm from '../components/WalkInApptForm.vue';
import InboundRemarkForm from '../components/InboundRemarkForm.vue';
import ReportLayoutForm from "../components/ReportLayoutForm.vue";

const getScaleControlSearch = () => ({
    mode: "list",
    appName: "SCALE_IN"
  });

const photoMetaLoading = [
    {
      display: "BOL SCAN",
      key: "BWT",
      fileName: "-BolScan.jpg",
    },
    //{
    //  display: "BOL Capture",
    //  key: "BWT1",
    //  fileName: "-BolPic.jpg",
    //},
  ];
const getInitSearch = () => ({
  salesOffice: null,
  transloadingYard: '1010001',
  receivingWindows: null,
  apptDate: null,
  dockType: null,
  selected: false,
  inboundShipment: null,
  po: null,
  inboundStatus: null,
  ibs_type: null,
  scaleTicket: null,
  moveInBy: null,
  supplier_name: null,
  bol: null,
  trucker_name: null,
  matnr_desc: null,
  qcIssue: null,
  ciDate: null,
  weightDifferent: null,
});
const getCreateDriver = () => ({
  name: null,
  platenum: null,
  phone: null,
  trailer: null,
});
const getInitView = () => ({
  salesOffice: true,
  transloadingYard: true,
  receivingWindows: true,
  apptDate: true,
  apptTime: true,
  apptNo: true,
  dockType: true,
  inboundShipment: true,
  block: true,
  inboundStatusO: true,
  inboundStatusC: true,
  inboundStatusR: true,
  inboundStatusL : true,
  inboundStatusN: true,
  workIn: true,
  externalTrucker: true,
  moveInBy: true,
  driverPh:true,
  driverLP: true,
  containerNo: true,
  ciDate: true,
  loadRemark: true,
  bol: true,
  bolWT: true,
  bolScan: true,
  bolGW: true,
  bolTW:true,
  bolNW: true,
  scaleCalled: true,
  callTime: true,
  gwStation: true,
  vgmWeight: true,
  gwDate: true,
  gwYgNo: true,
  gwYgWeight: true,
  scaleTicket: true,
  twStation: true,
  tareWeight:true,
  twDate : true,
  twYgNo: true,
  twYgWeight: true,
  weight: true,
  totalHours: true,
  plasticCount: true,
  palletCount: true,
  plasticWeight: true,
  palletWeight: true,
  weightDifferent: true,
  bales: true,
  looseCount: true,
  qcIssue: true,
  upgradeSuggestion: true,
  ibs_type: true,
  po: true,
  supplier_name: true,
  matnr: true,
  matnr_desc: true,
  po_lsd: true,
  trucker_name: true,
  route_desc: true,
  inco1: true,
  ac_name: true,
  buyer_name: true,
  sapStatus: true,
  unloadInfo: true,
  avm: true,
  moistureDedInLBS: true,
  moistureDedInPercent: true,
  wetNet: true,
  dryNet: true,
  originalGW: true,
  originalTW: true,

});
const getGenerateView = () => ({
  errorMsg: false,
  transloadingYard: false,
  receivingWindows: true,
  apptDate: true,
  apptTime: true,
  apptNo: true,
  dockType: true,
  inboundShipment: true,
  inboundStatusO: true,
  block: true,
  inboundStatus: true,
  noShow: true,
  externalTrucker: true,
});
const getUpdateView = () => ({
  errorMsg: false,
  transloadingYard: false,
  receivingWindows: true,
  apptDate: true,
  apptNo: true,
  dockType: true,
  inboundStatusO: true,
  inboundStatusC: true,
  inboundStatusR: true,
  inboundStatusL: true,
  block: true,
  inboundShipment: true,
  inboundStatusN: true,
  workIn: true,
  externalTrucker: true,
  apptTime: true,
  loadRemark: true,
  ibs_type: true,
  po: true,
  supplier_name: true,
  matnr: true,
  matnr_desc: true,
  po_lsd: true,
  trucker_name: true,
  route_desc: true,
  inco1: true,
  ac_name: true,
  buyer_name: true,
});
const getCheckInView = () => ({
  errorMsg: false,
  transloadingYard: false,
  receivingWindows: true,
  apptDate: true,
  apptTime: true,
  apptNo: false,
  dockType: false,
  inboundShipment: true,
  inboundStatusO: true,
  inboundStatusC: true,
  moveInBy: true,
  driverPh:true,
  driverLP: true,
  containerNo: true,
  ciDate: true,
  loadRemark: true,
  po: true,
  supplier_name: true,
  matnr: true,
  matnr_desc: true,
  trucker_name: true,
  route_desc: true,
  inco1: true,
  ac_name: true,
  buyer_name: true,
})
const getBolView = () => ({
  errorMsg: false,
  transloadingYard: false,
  receivingWindows: true,
  apptDate: true,
  apptTime: true,
  apptNo: false,
  dockType: false,
  inboundShipment: true,
  inboundStatusO: true,
  inboundStatusC: true,
  bol: true,
  bolWT: true,
  bolScan: true,
  bolGW: true,
  bolTW:true,
  bolNW: true,
  loadRemark: true,
  po: true,
  supplier_name: true,
  matnr: true,
  matnr_desc: true,
  trucker_name: true,
  route_desc: true,
  inco1: true,
  ac_name: true,
  buyer_name: true,
})
const getScaleCallView = () => ({
  errorMsg: false,
  transloadingYard: false,
  receivingWindows: true,
  apptDate: true,
  apptTime: true,
  apptNo: false,
  dockType: true,
  inboundShipment: true,
  inboundStatusC: true,
  inboundStatusO: true,
  moveInBy: true,
  driverPh: true,
  ciDate: true,
  scaleCalled: true,
  callTime: true,
  loadRemark: true,
  ibs_type: true,
  po: true,
  supplier_name: true,
  matnr: true,
  matnr_desc: true,
  trucker_name: true,
  route_desc: true,
  inco1: true,
  ac_name: true,
  buyer_name: true,
})
const getScaleGWView = () => ({
  errorMsg: false,
  transloadingYard: false,
  receivingWindows: true,
  apptDate: true,
  apptTime: true,
  apptNo: false,
  dockType: false,
  inboundShipment: true,
  callTime: true,
  loadRemark: true,
  gwStation: true,
  containerNo: true,
  vgmWeight: true,
  gwDate: true,
  gwYgNo: true,
  gwYgWeight: true,
  scaleTicket: true,
  moveInBy: true,
  ibs_type: true,
  po: true,
  supplier_name: true,
  matnr: true,
  matnr_desc: true,
  trucker_name: true,
  route_desc: true,
  inco1: true,
  ac_name: true,
  buyer_name: true,
  originalGW: true,
})
const getScaleTWView = () => ({
  errorMsg: false,
  transloadingYard: false,
  receivingWindows: true,
  apptDate: false,
  apptTime: false,
  apptNo: false,
  dockType: false,
  inboundShipment: true,
  loadRemark: true,
  moveInBy: true,
  scaleTicket: true,
  vgmWeight: true,
  gwDate: true,
  twStation: true,
  tareWeight:true,
  twDate : true,
  twYgNo: true,
  twYgWeight: true,
  weight: true,
  totalHours: true,
  plasticCount: true,
  palletCount: true,
  plasticWeight: true,
  palletWeight: true,
  weightDifferent: true,
  bales: true,
  looseCount: true,
  qcIssue: true,
  upgradeSuggestion: true,
  ibs_type: true,
  po: true,
  supplier_name: true,
  matnr: true,
  matnr_desc: true,
  trucker_name: true,
  route_desc: true,
  inco1: true,
  ac_name: true,
  buyer_name: true,
  avm: true,
  moistureDedInLBS: true,
  moistureDedInPercent: true,
  wetNet: true,
  dryNet: true,
  originalGW: true,
  originalTW: true,
})
const getInitEdit = () => ({
  mode : null,
  preSelect: false,
  apptDate: false,
  inboundShipment: false,
  block: false,
  inboundStatus: false,
  noShow: false,
  externalTrucker: false,
});
const generateEdit = () => ({
  mode : 'APPTG',
  apptDate: false,
  inboundShipment: false,
  block: true,
  inboundStatus: true,
  noShow: true,
  externalTrucker: true,
  apptTime: false
});
const updateEdit = () => ({
  mode : 'APPTU',
  apptDate: false,
  inboundShipment: true,
  block: true,
  inboundStatus: true,
  noShow: true,
  externalTrucker: true,
  apptTime: true,
  loadRemark: true,
});
const checkInEdit = () => ({
  mode : 'APPTC',
  inboundStatus: true,
  checkIn: true,
  moveInBy: true,
  driverPh:true,
  driverLP: true,
  containerNo: true,
  loadRemark: true,
});
const bolEdit = () => ({
  mode : 'APPTB',
  bol: true,
  bolWT: true,
  bolScan: true,
  bolGW: true,
  bolTW:true,
  bolNW: true,
  loadRemark: true,
});
const scaleCallEdit = () => ({
  mode : 'APPTS',
  scaleCalled: true,
  loadRemark: true,
});
const scaleGWEdit = () => ({
  mode : 'APPTGW',
  gwYgNo: true,
  gwYgWeight: true,
  loadRemark: true,
  containerNo: true,
});
const scaleTWEdit = () => ({
  mode : 'APPTTW',
  twYgNo: true,
  twYgWeight: true,
  totalHours: true,
  plasticCount: true,
  palletCount: true,
  plasticWeight: true,
  palletWeight: true,
  weightDifferent: true,
  looseCount: true,
  upgradeSuggestion: true,
  loadRemark: true,
});
const reportLayoutElements = () => ({
   orderIndex: null,
   colHeaderText: null,
   colDataElement: null,
   colDataType: null,
   colWidth: null,
});
const getInitialLayoutSearchRequest = () => ({
   office: null,
   layoutOwner: null,
   layoutName: null,
   reportModule: null,
   colIndex: null,
   onlyActive: null,
   layoutnamelist: null,
});

export default {
  data: () => ({
    searchRequest: getInitSearch(),
    drivers: [],
    driver: getCreateDriver(),
    dialog: {
      isShowing: false,
    },
    transferTicketStatus: false,
    transferTicketItem: [],
    weightTicketStatus: false,
    weightTicketItem: [],
    items: [],
    scalecontrolSearch: getScaleControlSearch(),
    scalecontrol: [],
    itemsCopy: [],
    sumItems: [],
    sideBar: false,
    test: false,
    ibsError: [],
    isFilterModalShowing:false,
    edit: getInitEdit(),
    filterConfirmed: false,
    modalMessage: "",
    isWarning: false,
    //active: false,
    active: true,
    containerCopy: false,
    filter: "",
    notifyActive: false,
    notifyMessage: null,
    viewFilter: getInitView(),
    isAblePrint: false,
    checkin: false,
    call: false,
    scaleload: false,
    scalegross: false,
    isdisableSend: true,
    isdisablephoto: true,
    isPictureModalShowing: false,
    photos: [],
    saveCheckInRequest:{
        receivingWindows: " ",
        checkIn: " ",
        username: " ",
        seqNo: " ",
        inboundShipment: " ",
        inboundStatus: " ",
        block: " ",
        apptNo: " ",
        apptDate: " ",
        apptDateTime: " ",
        ciDate: " ",
        moveInBy: " ",
        driverPh: " ",
        driverLP: " ",
        containerNo: " ",
        externalTrucker: " ",
      },
    trimOption: [
      "inboundShipment",
      "po",
      "scaleTicket",
      "moveInBy",
      "supplier_name",
      "bol",
      "trucker_name",
      "matnr_desc",
      "qcIssue"
    ],
    processAppt: false,
    p_user_location: null,
    p_lgb_rec_wins: [],
    p_wil_rec_wins: [],
    p_office_ips: new Map(),
    buttonshow: false,
    loaded_user_layout: [],
    loaded_default_allCols: [],
    layout_type: 'Scale Layout',
    loaded_layout_userspec: false,
    loaded_layout_setdefault: false, 
    selectedLayout: null,
    userLayoutNameList: [],
    inbound_recwin: [], 
    inbound_recwin_id: [],

  }),
  components: {
    callingApiCenter,
    InboundForm,
    DoubleLine,
    WindowPortal,
    TransferTk,
    BolPhotoForm,
    BolPhotoZoomForm,
    //DriverForm,
    FSIDriverForm,
    DriverSMSForm,
    WebCamForm,
    QrcodeVue,
    TicketManagement,
    WalkInForm,
    InboundRemarkForm,
    ReportLayoutForm,
  },
  watch: {
    getInboundsList(val) {
      this.updateItems(val);
    },
    // eslint-disable-next-line
    "searchRequest.teams"() {
      this.searchRequest.users = [];
    },
  },
  computed: {
    ...mapGetters([
      "getInboundsList",
      "getMasterDataName",
      "getMasterDataByGroup",
      "getMasterDataAsSelectOptionByGroup",
      "getPermission",
      "getUserProfile",
      "getRole",
      "getUserLocation",
      "getUserIP",
      "getUserAllowRecWin"
    ]),
    filteredRows() {
      //var items = this.items.filter(it => this.inbound_recwin_id.includes(it.receivingWindows));
      return this.items.filter((row) => {
      //return items.filter((row) => {
        const term = this.filter.toUpperCase().trim();
        return (
          this.includeNull(row.scaleTicket).includes(term) ||
          this.includeNull(row.inboundShipment).includes(term)
        );
      });
    },
    getSelectedItems() {
      return _(this.items).filter((it) => it.selected);
    },
    // getWaitingForCallF(){
    //   return this.items.filter((it) => it.inboundStatus == 'C' && it.scaleCalled != 'X' && it.dockType == 'Flat Bed').length;
    // },
    // getWaitingForCallN(){
    //   return this.items.filter((it) => it.inboundStatus == 'C' && it.scaleCalled != 'X' && it.dockType == 'Normal').length;
    // },
    getWaitingForCallF(){
      return this.sumItems.filter((it) => it.inboundStatus == 'C' && it.scaleCalled != 'X' && it.dockType == 'Flat Bed').length;
    },
    getWaitingForCallN(){
      return this.sumItems.filter((it) => it.inboundStatus == 'C' && it.scaleCalled != 'X' && it.dockType == 'Normal').length;
    },
    getWaitingForGWN(){
      return this.sumItems.filter((it) => it.vgmWeight == null && it.scaleCalled == 'X' && it.dockType == 'Normal').length;
    },
    getWaitingForGWF(){
      
      return this.sumItems.filter((it) => it.vgmWeight == null && it.scaleCalled == 'X' && it.dockType == 'Flat Bed').length;
    },
    getUploadingN(){
      
      return this.sumItems.filter((it) => it.tareWeight == null && it.vgmWeight != null && it.dockType == 'Normal').length;
    },
    getUploadingF(){
      return this.sumItems.filter((it) => it.tareWeight == null && it.vgmWeight != null && it.dockType == 'Flat Bed').length;
    },
    getOpenLoadN() {
      return this.sumItems.filter((it) => it.inboundStatus == 'O' && (it.inboundShipment != null && it.inboundShipment != '') && it.dockType == 'Normal').length;
    },
    getOpenLoadF() {
      return this.sumItems.filter((it) => it.inboundStatus == 'O' && (it.inboundShipment != null && it.inboundShipment != '') && it.dockType == 'Flat Bed').length;
    },
    getTWScaledN(){
      return this.sumItems.filter((it) => (!(it.inboundStatus == 'R' || it.tareWeight == null)) && it.dockType == 'Normal').length;
    },
    getTWScaledF(){
      return this.sumItems.filter((it) => (!(it.inboundStatus == 'R' || it.tareWeight == null)) && it.dockType == 'Flat Bed').length;
    },
    getRecLoadN(){
      return this.sumItems.filter((it) => it.inboundStatus == 'R' && it.dockType == 'Normal').length;
    },
    getRecLoadF() {
      return this.sumItems.filter((it) => it.inboundStatus == 'R' && it.dockType == 'Flat Bed').length;
    },
    getPrintCond(){
      const items = this.getSelectedItems;
      if (items.length === 1 && this.isAblePrint == true && items[0].containerNo != null)
      {
          return true
      }
      else
      {
        return false
      }
    },
    getSaveCond() {
      console.log(`getsavecond`);
      const editItem = this.items.filter(it  => this.hasBeenChanged(it));
      console.log(`getsavecond edititem: ${JSON.stringify(editItem)}`);
      if (editItem.length === 0) return false;
      if (this.edit.mode == 'APPTC')
      {
        
        const items = _(editItem).filter((it) => {
          if (it.inboundStatus == 'C')
          {
            // if (it.moveInBy == null || it.moveInBy == '')
            // {
            //   return true
            // }
            // if (it.driverPh == null || it.driverPh == '')
            // {
            //   return true
            // }
            // if (it.containerNo == null || it.containerNo == '')
            // {
            //   return true
            // }
            return false
          }
          else
          {
            return false
          }
        });
        if (items.length == 0)
        {
          return true
        }
        else
        {
          return false
        }
      }
      else
      {
         return true
      }
      
     
    },
    getSummaryCond() {
      return this.edit.mode == 'APPTS'
    },
    
    getTicketManagement() {
      const item = _(this.items).filter((it) => it.selected && (it.sapStatus == null || it.sapStatus != 'X'));
      if (this.edit.mode == null || this.edit.mode == 'APPTTW')
      {
        return item.length === 1 && item[0].vgmWeight != null 
      }
      else
      {
        return false
      }
      
    },

    getScaledCond() {
      
      if (this.edit.mode == 'APPTGW' || this.edit.mode == 'APPTTW' )
      {
            const item = _(this.items).filter((it) => it.selected);
            if (item.length === 1)
              {
                if (item[0].sapStatus == null || item[0].sapStatus != 'X')
                {
                  return true;
                }
                else
                {
                  return false;
                }
                
              }
            else
              {
                return false;
              }
      }
      else
      {
        return false;
      }
      
    },
    getDownloadCond() {
      
      const item = _(this.items).filter((it) => it.selected);
      if ( this.edit.mode == null && this.items.length != 0 && item.length == 0  ) return this.items;
  
    },
  },
  async mounted() {
    //  if (this.$el.querySelector("#expand-button"))  
    //     this.$el.querySelector("#expand-button").click();
    const cachedSearchRequest = this.$store.state.inbound.searchRequest;
    if (cachedSearchRequest) {
      this.searchRequest = JSON.parse(JSON.stringify(cachedSearchRequest));
    }
    this.searchRequest.salesOffice = this.getUserProfile.defaultSalesOffice;
    //this.searchRequest.receivingWindows = this.getUserProfile.recWindow;
    if (this.getUserProfile.recWindow == "99")
    {
      this.searchRequest.receivingWindows = "185";
    } else {
      this.searchRequest.receivingWindows = this.getUserProfile.recWindow;
    }
    //const allCcicUsers = JSON.stringify(this.getGSTDriverMaster);
    // const allCcicUsers = await this.$store.dispatch(
    //       'getDriversByFSI',
    //       {
    //         defaultSalesOffice: 'LGB',
    //         driverOffice: 'FSI',
    //       },
    //     );
    // this.drivers = allCcicUsers;
    // this.drivers = await api.post('/api/w/gstMasterData/driverMasterData', { defaultSalesOffice: 'LGB', driverOffice: 'FSI'})
    // // .then ( (driverinfo) => {
    // //    if (driverinfo) {
    // //      this.drivers = driverinfo;
    // //    }
    // // }
    // // )
    // .then(res => _.chain(res)
    //       .map(it => ({
    //         id: it.shortId,
    //         name: it.driverMobile,
    //         plate: it.defaultPlateNum,
    //         trail: it.trailernum,
    //       }))
    //       .sortBy(it => it.id)
    //       .value());    
    // this.drivers = await api.post('/api/w/fsi/searchDriverData', {currentDrivers: true})
    //       .then( resdrivers => _.chain(resdrivers)
    //              .map(it => ({
    //                 id: it.driverId,
    //                 name: it.fullName + " / " + it.driverMobile,
    //                 mobile: it.driverMobile,
    //                 trail: it.trailerNum,
    //              }))
    //              .sortBy(it => it.id)
    //              .value());
    // console.log("drivers: " + JSON.stringify(this.drivers));
    this.refreshFSIDriverList();
    if (this.getUserLocation == null || this.getUserLocation == '')
    {
       console.log("reload user location due to empty");
       await this.$store.dispatch('checkUserLocation')
         .then (() => {
           this.p_user_location = this.getUserLocation;       
           console.log("inbound - reload user location: " + JSON.stringify(this.p_user_location));
           console.log(`inbound - reload get allow rec win ${JSON.stringify(this.getUserAllowRecWin)}`);
           //if (this.p_user_location == '"ACNI"')
          //  if (this.p_user_location == 'LONG BEACH')
          //  {
          //     console.log("this is matched " + this.p_user_location);
          //  }
          //  else {
          //     console.log("unable to match location" + this.p_user_location);
          //  }
         })
       ;
    } else {
      this.p_user_location = this.getUserLocation;
      console.log("inbound - user location: " + this.p_user_location);
      console.log(`inbound - get allow rec win ${JSON.stringify(this.getUserAllowRecWin)}`);
      //if (this.p_user_location == '"ACNI"')
          //  if (this.p_user_location == 'LONG BEACH')
          //  {
          //     console.log("this is matched " + this.p_user_location);
          //  }
          //  else {
          //     console.log("unable to match location" + this.p_user_location);
          //  }
    }
    this.doReloadLayout();
    // var p_office = "";
    // var p_offices = [];
    // var p_allow_win = [];

    // var t_getips = this.getMasterDataByGroup('OFFICE_IP');
    // t_getips.forEach( (it) => {
    //      p_offices.push(it.tagId);
    // });
    // console.log(`p_offices: ${JSON.stringify(p_offices)}`);
    // if (p_offices && p_offices.length > 0)
    // {
    //     p_offices.forEach((it) => {
    //       p_office = it;
    //       p_allow_win = [];
    //       console.log(`process office: ${p_office}`);
    //       console.log(`allow rec win: ${JSON.stringify(this.getMasterDataByGroup('ALLOW_REC_WIN'))}`);
    //       this.filterlocation(this.getMasterDataByGroup('ALLOW_REC_WIN'),p_office)
    //       .forEach((it) => {
    //          console.log(`allow rec win: ${JSON.stringify(it)}`);
    //          p_allow_win.push(it.recWindow);
    //       });
    //       this.p_office_ips.set(p_office, p_allow_win);
    //     });
    // }

    console.log(`office ips: ${JSON.stringify(this.p_office_ips)}`);  
    console.log(`inbound - allow rec win: ${JSON.stringify(this.getUserAllowRecWin)}`)
    console.log(`rec win: ${JSON.stringify(this.getMasterDataByGroup('REC_WINDOW').filter( it => it.tagName != 'STC'))}`);
    this.inbound_recwin = this.getMasterDataByGroup('REC_WINDOW').filter( it => it.tagName != 'STC');
    if (this.inbound_recwin.length > 0)
      {
         this.inbound_recwin.forEach((it) => {
            this.inbound_recwin_id.push(it.tagId);
         }) 
      }
    // console.log(`LGB rec windows: ${JSON.stringify(this.getMasterDataByGroup('LGB_REC_WIN'))}`);
    // this.getMasterDataByGroup('LGB_REC_WIN').forEach((it) => {
    //      p_office = it.tagName;
    //      this.p_lgb_rec_wins.push(it.tagId);
    // });
    // this.p_office_ips.set(p_office, this.p_lgb_rec_wins);

    // console.log(`WIL rec windows: ${JSON.stringify(this.getMasterDataByGroup('WIL_REC_WIN'))}`);
    // p_office = "";
    // this.getMasterDataByGroup('WIL_REC_WIN').forEach((it) => {
    //      p_office = it.tagName;
    //      this.p_wil_rec_wins.push(it.tagId);
    // });
    // this.p_office_ips.set(p_office, this.p_wil_rec_wins);
    // var t_getips = this.getMasterDataByGroup('OFFICE_IP');
    // //var test_location = new Map();
    // t_getips.forEach((it) => {
    //     console.log(`location: ${it.tagName} ip: ${it.tagId}`);
    //     this.p_office_ips.set(it.tagName, it.tagId);
    // });
    // console.log(`getuserip: ${this.getUserIP}`);
    // console.log(`user location is ${this.p_office_ips.get(this.getUserIP)} with ip ${this.getUserIP}`);

    // console.log(`p_lgb_rec_wins: ${JSON.stringify(this.p_lgb_rec_wins)}`);
    // console.log(`p_wil_rec_wins: ${JSON.stringify(this.p_wil_rec_wins)}`);
    // this.$el.querySelector("#searchTag").click();
    // this.updateItems(this.getInboundsList);
  },
  methods: {

    trimTool(ent) {
      return ent == null ? null : ent.trim()
    },

    getPhotoName(photo) {
      const photoName = decodeURI(photo.photoUrl.replace(/.*\//g, ""));
      return `${this.filePrefixForEachFile || ''}${photoName}`;
    },

    getPhotos(item){
      this.isPictureModalShowing = true;
      this.photos = [];
      const selectedItem = item;
       console.log(selectedItem);
      if (selectedItem.scanWtLink != null)
      {
        let item = {
          title: "Scan Weight Ticket Image",
          photoUrl : selectedItem.scanWtLink
        };
        this.photos.push(item);
        
      }
       
    },


    resetTime(item){
      if (item.apptTime == '')
      {
        item.apptTime = '00:00:00';
      }
      
    },
  
    doCalPalletWgt(item) {
       var validationErr = false;
       console.log(`pallet count: ${item.palletCount}`);
       if (item.palletCount == null || item.palletCount == '')
       {
         item.palletWeight = 0;
       } else {
         if (!Number.isInteger(Number(item.palletCount))) {
            console.log(`pallet count is not an integer`);
            validationErr = true;
         } else {
           if (Number(item.palletCount) < 0)
           {
             console.log(`pallet count is neg num`);
             validationErr = true;
           }
         }
       }
       if (!validationErr)
       {
          item.palletWeight = Number(item.palletCount) * 60;
       } else {
          //alert("Pallet Count has to be a postive integer number!"); 
       }
    },

    numberOnly(e){
     const key = e.key;
     if (/[^0-9]+/g.test(key))
      {
        if (key != 'Backspace' && key != 'Tab')
        {
          return e.preventDefault();
        }
      }
    },

    decOnly(e){
     const key = e.key;
     if (/[^0-9]+/g.test(key))
      {
        if (key != 'Backspace' && key != '.' && key != 'Tab')
        {
          return e.preventDefault();
        }
      }
    },
//     print() {
//       var prtContent = document.createElement('div');
//       var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
//       prtContent.innerHTML = 'ddd'
//     //  WinPrint.document.write(prtContent.innerHTML);
//     WinPrint.document.write(`
  
//   <!doctype html>
// <html lang="en">
// <head>
//   <meta charset="utf-8">
//   <title>The HTML5 Herald</title>
//   <meta name="description" content="The HTML5 Herald">
//   <meta name="author" content="SitePoint">
// </head>
// <body>
//   <div id = "test">
//               <test></test>
//   </div>
// </body>
// </html>
//     `);
 
//       WinPrint.document.close();
//       // WinPrint.focus();
//       // WinPrint.print();
//       // WinPrint.close();
//     },

    filterlocation : (value, location) => value.filter( it => it.location == location),
    handleWindowsChanged(id) {
        this.searchRequest.receivingWindows = id;
    },
    handleStatusChanged(id) {
      this.searchRequest.inboundStatus = id;
    },
    handleIBSChanged(id, name) {
       this.searchRequest.ibs_type = name;
    },
    handleDockChanged(id) {
        this.searchRequest.dockType = id;
    },
    handleYGChanged(item) {
      return (id,name,unit, weight) => {
        if (id != null)
        {
          item.gwYgNo = id;
          item.gwYgWeight = weight;
        }
        else
        {
          item.gwYgNo = null;
          item.gwYgWeight = null;
        }
          
        };
    },
    handleYGTWChanged(item){
      return (id,name,unit, weight) => {
        if (id != null)
        {
          item.twYgNo = id;
          item.twYgWeight = weight;
        }
        else
        {
          item.twYgNo = null;
          item.twYgWeight = null;
        }
          
        };
    },
    handleSuggestionChanged(){
    },
    handleDriverChanged(item) {
        //   return (id, name, mobile, tractornum, trailernum, apptNo) => {
        //      console.log(`return change: ${id} ${name} ${mobile} ${apptNo}`)
        //      item.moveInBy = name;
        //      item.driverPh = mobile;
        //      item.driverLP = trailernum;
        // // return (id, name, unit, weight, plate, trail) => {
        // //   item.moveInBy = id;
        // //   item.driverPh = name;
        // //   item.driverLP = plate;
        //   // item.containerNo = trail;
        //   this.refreshCurrentList();
          
        // };
        return (val) => {
          console.log(`handle driver change: ${JSON.stringify(item)} ${val}`);
          console.log(`drivers list: ${JSON.stringify(this.drivers)}`);
          var selectedDriver = this.drivers.filter((it) => it.id == val);
          //item.moveInBy = selectedDriver[0].name;
          if (selectedDriver != null && selectedDriver.length > 0)
          {
            console.log(`selected driver: ${JSON.stringify(selectedDriver)}`);
            console.log(`selected driver mobile: ${selectedDriver[0].mobile}`);
            console.log(`selected driver trailer: ${selectedDriver[0].trail}`);
            item.moveInBy = val;
            item.driverPh = selectedDriver[0].mobile;
            item.driverLP = selectedDriver[0].trail;
            this.refreshCurrentList();
          } else {
            item.moveInBy = "";
            item.driverPh = "";
            item.driverLP = "";
            this.refreshCurrentList();
          }

        };
      },
      handleCreationDriver(item) {
        // window.alert('noop')
        return () => {
          //this.$refs.DriverFormCreate.openDialog(item.apptNo);
          this.$refs.FSIDriverFormCreate.openDialog(item);
        }
      },
    hasBeenChanged(item) {
        const lhs = _(this.getInboundsList)
          .find(it => it.apptNo === item.apptNo);
        // for (let [key, value] of Object.entries(item)) {
        //   console.log(`${key}: ${value}`);
        // }
        console.log(`has been changed condition`);
        if (item.inboundShipment == '') item.inboundShipment = null;
        if (item.externalTrucker == '') item.externalTrucker = null;
        if (item.moveInBy == '') item.moveInBy = null;
        if (item.driverPh == '') item.driverPh = null;
        if (item.containerNo == '') item.containerNo = null;
        //if (item.loadRemark == '') item.loadRemark = null;
        if (item.bol == '') item.bol = null;
        if (item.bolGW == '') item.bolGW = null;
        if (item.bolTW == '') item.bolTW = null;
        if (item.bolNW == '') item.bolNW = null;
        if (item.bolWT == '') item.bolWT = null;
        if (item.weight == '') item.weight = null;
        if (item.totalHours == '') item.totalHours = null;
        if (item.plasticCount == '') item.plasticCount = null;
        if (item.plasticCount == '') item.plasticCount = null;
        if (item.palletCount == '') item.palletCount = null;
        if (item.plasticWeight == '') item.plasticWeight = null;
        if (item.palletWeight == '') item.palletWeight = null;
        if (item.weightDifferent == '') item.weightDifferent = null;
        
        if (lhs) {
          return (lhs.block !== item.block)
            || (lhs.inboundStatus !== item.inboundStatus)
            || (lhs.workIn !== item.workIn)
            || (lhs.externalTrucker !== item.externalTrucker)
            || (lhs.inboundShipment !== item.inboundShipment)
            || (lhs.apptTime !== item.apptTime)
            || (lhs.moveInBy !== item.moveInBy)
            || (lhs.driverPh !== item.driverPh)
            || (lhs.driverLP !== item.driverLP)
            || (lhs.containerNo !== item.containerNo)
            || (lhs.ciDate !== item.ciDate)
            //|| (lhs.loadRemark !== item.loadRemark)
            || (lhs.bol !== item.bol)
            // || (lhs.bolScan !== item.bolScan)
            || (lhs.bolGW !== item.bolGW)
            || (lhs.bolTW !== item.bolTW)
            || (lhs.bolNW !== item.bolNW)
            || (lhs.bolWT !== item.bolWT)
            || (lhs.scaleCalled !== item.scaleCalled)
            || (lhs.callTime !== item.callTime)
            || (lhs.gwStation !== item.gwStation)
            || (lhs.vgmWeight !== item.vgmWeight)
            || (lhs.gwDate !== item.gwDate)
            || (lhs.gwYgNo !== item.gwYgNo)
            || (lhs.gwYgWeight !== item.gwYgWeight)
            || (lhs.twStation !== item.twStation)
            || (lhs.tareWeight !== item.tareWeight)
            || (lhs.twDate !== item.twDate)
            || (lhs.weight !== item.weight)
            || (lhs.totalHours !== item.totalHours)
            || (lhs.twYgNo !== item.twYgNo)
            || (lhs.twYgWeight !== item.twYgWeight)
            || (lhs.plasticCount !== item.plasticCount)
            || (lhs.palletCount !== item.palletCount)
            || (lhs.plasticWeight !== item.plasticWeight)
            || (lhs.palletWeight !== item.palletWeight)
            || (lhs.weightDifferent !== item.weightDifferent)
            || (lhs.bales !== item.bales)
            || (lhs.looseCount !== item.looseCount)
            || (lhs.qcIssue !== item.qcIssue)
            || (lhs.upgradeSuggestion !== item.upgradeSuggestion)
            || (lhs.upgradeBales !== item.upgradeBales)
            || (lhs.scanWt !== item.scanWt)
            
        
        }
        return false;
      },
    checkBlock(item){
       if (item.inboundStatus == 'R') return;
      if (!this.edit.block) return
      if (item.block == 'X') 
      {
        item.block = null;
      }
      else
      {
        item.block = 'X'
      }
      
    },
    
    checkWorkIn(item){
       if (item.inboundStatus == 'R') return;
      if (!this.edit.block) return
      if (item.workIn == 'X') 
      {
        item.workIn = null;
      }
      else
      {
        item.workIn = 'X'
      }
      
    },
    checkScaleCall(item){
      if (!this.edit.scaleCalled) return
      
      if (item.scaleCalled == 'X') 
      {
        item.scaleCalled = null;
        item.callTime = null;
      }
      else
      {
        item.scaleCalled = 'X'
        item.callTime = dateFormat.getLocalDateOnly(moment().toDate()) + 'T' + dateFormat.time(moment().toDate())
      }
      
    },
    checkNoShow(item){
       if (item.inboundStatus == 'R') return;
      if (!this.edit.noShow) return
      if (item.noShow == 'X') 
      {
        item.noShow = null;
      }
      else
      {
        item.noShow = 'X'
      }
      
    },
    checkInboundStatus(item, option){
      if (!this.edit.inboundStatus) return;
      if (item.inboundStatus == 'R') return;
      
      if (this.edit.mode == 'APPTU')
      {
        if (option == 'C' || option == 'R') return;
      }
      if (this.edit.mode == 'APPTC')
      {
        if (option == 'O' || option == 'R') return;
      }
      // if (item.inboundStatus == 'C' && option == 'O') return;
      if (item.inboundStatus == option) 
      {
        item.inboundStatus = 'O';
        if (option == 'C') 
        {
          item.ciDate = null;
          // item.moveInBy = null;
          // item.driverPh = null;
          // item.driverLP = null;
          // item.containerNo = null;
        }
      }
      else
      {
        item.inboundStatus = option
        if (option == 'C')
        {
          item.ciDate = dateFormat.getLocalDateOnly(moment().toDate()) + 'T' + dateFormat.time(moment().toDate())
        }
        else
        {
          item.ciDate = null;
          item.ciDate = null;
          item.moveInBy = null;
          item.driverPh = null;
          item.driverLP = null;
          item.containerNo = null;
        }
      }
    },
    noRemark() {
       console.log("no remark" + this.getSelectedItems.length);
       if (this.getSelectedItems.length == 1)
          return false;
       else 
          return true;
    },
    refreshSelectList() {
       const selectedItems = this.items.filter((it) => it.selected);
       this.items = [];
       this.items = selectedItems; 
    },
    refreshCurrentList() {
      const currentItems = this.items;
      this.items = [];
      this.items = currentItems; 

    },
    async refreshFSIDriverList() {
      //this.drivers = await api.post('/api/w/fsi/searchDriverData', {currentDrivers: true, onlyActive: true})
      this.drivers = await newAPIPost('/api/w/fsi/searchDriverData', {currentDrivers: true, onlyActive: true})
          .then( resdrivers => _.chain(resdrivers)
                 .map(it => ({
                    id: it.driverId,
                    name: it.fullName + " / " + it.driverMobile,
                    mobile: it.driverMobile,
                    trail: it.trailerNum,
                 }))
                 .sortBy(it => it.id)
                 .value());
      console.log("drivers: " + JSON.stringify(this.drivers));
    },
    sortFunction(sortFiled) {
      const sorted = sort(this.items).asc(sortFiled);
      this.sortStatus = !this.sortStatus;
      if (this.sortStatus) {
        this.items = sorted;
      } else {
        this.items = sorted.reverse();
      }
    },
    sortSingleWay(sortFiled) {
      sort(this.items).asc(sortFiled);
    },
    sortM(...args) {
      sort(this.items).asc(args);
    },
    includeNull(field) {
      return field == null ? "" : field;
    },
    mouseOver: function () {
      this.active = true;
    },
    mouseLeave: function () {
      this.active = !this.active;
    },
    updateItems(itemsSource, isDisplay = false) {
      $('#tableId').scrollLeft(0);
      var items = JSON.parse(JSON.stringify(itemsSource));
      items.forEach((it) => {
        it.backGroud = false;
        it.selected = false;
        it.editing = false;
        it.loading = false;
        it.ibsError = null;
        it.gwygError = null;
        it.twygError = null;
        it.plCtError = null;
        it.paCtError = null;
        it.plWeError = null;
        it.paWeError = null;
        it.twScaleError = null;
        it.gwWarning = null;
        it.twWarning = null;
        it.netWarning = null;
        
      });
      this.items = items;
      this.itemsCopy = items;
      if (this.edit.mode == '0')
      {
        this.sortM(['transloadingYard', 'receivingWindows', 'apptDate', 'dockType'])
      }
      if (this.edit.mode == 'APPTG')
      {
        this.sortM(['transloadingYard', 'receivingWindows', 'apptDate'])
      }
      if (this.edit.mode == 'APPTU')
      {
        this.sortM(['transloadingYard', 'receivingWindows', 'apptDate'])
      }
      if (this.edit.mode == 'APPTC' && isDisplay == false)
      {
        if (this.checkin == true)
        {
            // this.items = _(this.itemsCopy).filter((it) => ( it.inboundStatus == 'C' && it.vgmWeight == null ) || ((it.inboundStatus == 'O' && it.block == null) && it.inboundShipment != null)) ;
            this.items = _(this.itemsCopy).filter((it) => ( it.inboundShipment != null)) ;
        }
        else
        {
            this.items = _(this.items).filter((it) => (it.inboundStatus == 'O' && it.block == null) && it.inboundShipment != null);
        }
        this.sortM(['transloadingYard', 'receivingWindows', 'apptDate'])
      }
      if (this.edit.mode == 'APPTB' && isDisplay == false)
      {
        this.items = _(this.items).filter((it) => it.inboundShipment != null);
        this.sortM(['transloadingYard', 'receivingWindows', 'apptDate'])
      }
      if (this.edit.mode == 'APPTS' && isDisplay == false)
      {
        this.sumItems = this.items;
        if (this.call == true)
        {
         
          this.items = _(this.itemsCopy).filter((it => (it.inboundStatus == 'C' && it.vgmWeight == null) || (it.vgmWeight != null && it.tareWeight == null)))  
        }
        else
        {
         
          this.items = _(this.items).filter((it) => it.inboundStatus == 'C' && it.vgmWeight == null);
        }
        this.sortM(['transloadingYard', 'receivingWindows', 'ciDate'])
      }
      if (this.edit.mode == 'APPTGW' && isDisplay == false)
      {
        if (this.scalegross == true)
        {
          this.items = _(this.itemsCopy).filter((it => ((it.inboundStatus == 'C' && it.vgmWeight == null) || (it.vgmWeight != null && it.tareWeight == null))))
        }
        else
        {
          this.items = _(this.items).filter((it) => it.inboundStatus == 'C' && it.vgmWeight == null);
        }
        this.sortM(['transloadingYard', 'receivingWindows', 'ciDate'])
      }
      if (this.edit.mode == 'APPTTW' && isDisplay == false)
      {
        if (this.scaleload == true)
        {
          this.items = _(this.itemsCopy).filter((it => ((it.vgmWeight != null && it.tareWeight == null) || (it.vgmWeight != null && it.tareWeight != null) ) ) )
        }
        else
        {
          this.items = _(this.items).filter((it) => it.vgmWeight != null && it.tareWeight == null);
        }
        this.sortM(['transloadingYard', 'receivingWindows', 'ciDate','gwDate'])
      }
     
      if (this.edit.preSelect == true)
      {
        if (this.items.length === 1)
        {
          this.items[0].selected = true;
        }
      }
    //   this.sortSingleWay("loadStatus");
    },
    handleScroll(e) {
      if (this.$el)
      {
        if ($(this.$el.querySelector(".table-header"))) {
          $(this.$el.querySelector(".table-header")).offset({
            left: -1 * (e.target.scrollLeft - $(".outer-container").offset().left),
          });
        }
      }
    },
    async doSave(){
     
      console.log(this.edit.mode);
      if (this.edit.mode == "APPTG")
      {
        this.saveApptG();
      }
      if (this.edit.mode == "APPTU")
      {
        this.saveApptU();
      }
      if (this.edit.mode == "APPTC")
      {
        this.saveApptC();
      }
      if (this.edit.mode == "APPTB")
      {
        this.saveApptB();
      }
      if (this.edit.mode == "APPTS")
      {
        this.saveApptS();
      }
      if (this.edit.mode == "APPTGW")
      {
        this.saveApptGW();
      }
      if (this.edit.mode == "APPTTW")
      {
        this.saveApptTW();
      }

      // APPTTM
      // if (this.edit.mode == null)
      // {
      //   this.saveApptTM();
      // }
    },
    onChangeCheckIn(e) {
       this.$nextTick(() => {
         console.log(this.checkin, e)
       })
    },
    saveApptG()
    {
      const editItem = this.items.filter(it  => this.hasBeenChanged(it));
        var result = [];
        const allApiCalls = _(editItem).chain().map((it) => {
                  return new Promise((resolve) => {
                    //api.post(
                    newAPIPost(
                      '/api/w/fsi/WebSaveInbound',
                      {
                        mode: 'APPTG',
                        username : this.getUserProfile.username,
                        apptNo: it.apptNo,
                        apptSeq: it.apptSeq,
                        block: it.block,
                        inboundStatus: it.inboundStatus,
                        externalTrucker: it.externalTrucker,
                      },
                    ).then((data) => {
                        // result.push(data);
                        // resolve(data);
                        it.errorMsg = data;
                        resolve(it)
                      }).catch((err) => {
                        // result.push(err.messages.join(';'));
                        // resolve(err);
                        it.errorMsg = err.messages.join(';');
                        resolve(it)
                      });
                  });
                }).value();
                Promise.all(allApiCalls).then((results) => {
                  const resultData = [];
                  _(results)
                    .each(it => resultData.push(it));
                    this.$store.commit("updateInbound", resultData);
                    this.updateItems(this.getInboundsList);
                    this.viewFilter.errorMsg = true;
                    this.edit = getInitEdit();
                    this.notifyActive = true;
                    const hasError = _(results).filter((it) => it.errorMsg != null);
                    if (hasError.length == 0)
                    {
                      this.notifyMessage = "Below containers have been updated!"
                      
                    }
                    else
                    {
                      this.notifyMessage = "Some of the items have not been saved , please check error message to learn detial! "
                    }
                    
                    
                });
    },
    saveApptU()
    {
      const editItem = this.items.filter(it  => this.hasBeenChanged(it));
      const hasIbsError = editItem.filter(it => it.ibsError != null);
      if (hasIbsError.length != 0)
      {
        this.$buefy.notification.open({
                    duration: 5000,
                    message: `Some of items have ibs errors!`,
                    position: 'is-top-right',
                    type: 'is-danger',
                    hasIcon: true
                })
        return 
      }
        var result = [];
        // need save apptTime to apptDate
        const filterItems = editItem.filter(it  => it.inboundShipment != null && it.inboundShipment != '')
        const dupError = [...new Set(filterItems.map(s => s.inboundShipment))];
        var invaliateDate = false;
        if (dupError.length != filterItems.length)
        {
          this.$buefy.notification.open({
                    duration: 5000,
                    message: `Some of items have duplicate Ibs!`,
                    position: 'is-top-right',
                    type: 'is-danger',
                    hasIcon: true
                })
        return 
        }
       
        editItem.forEach((it) => {
        const apptDate = dateFormat.getLocalDateOnly(it.apptDate) + 'T' + it.apptTime;
        if (moment(apptDate).toDate() == 'Invalid Date')
        {
          invaliateDate = true;
        }
        else
        {
          it.apptDate = apptDate;
        }
       
      });
      if (invaliateDate == true)
      {
        this.$buefy.notification.open({
                    duration: 5000,
                    message: `Some of items have wrong time!`,
                    position: 'is-top-right',
                    type: 'is-danger',
                    hasIcon: true
                })
        return 
      }
      // ***************** Testing output
      // console.log(editItem.map((it) => (
      //   {
      //                   mode: 'APPTU',
      //                   apptNo: it.apptNo,
      //                   apptSeq: it.apptSeq,
      //                   block: it.block,
      //                   inboundStatus: it.inboundStatus,
      //                   workIn: it.workIn,
      //                   inboundShipment: it.inboundShipment,
      //                   inboundSeq: it.inboundSeq,
      //                   externalTrucker: it.externalTrucker,
      //                   loadRemark: it.loadRemark,
      //                   moveInBy: it.moveInBy,
      //                   driverPh: it.driverPh,
      //                   driverLP: it.driverLP,
      //                   containerNo: it.containerNo,
      //                   ciDate: it.ciDate,
      //                   apptDate: it.apptDate,
      //                 }
      // )
        
      // ))
      //   return
        const allApiCalls = _(editItem).chain().map((it) => {
                  return new Promise((resolve) => {
                    //api.post(
                    newAPIPost(
                      '/api/w/fsi/WebSaveInbound',
                      {
                        mode: 'APPTU',
                        username : this.getUserProfile.username,
                        apptNo: it.apptNo,
                        apptSeq: it.apptSeq,
                        block: it.block,
                        inboundStatus: it.inboundStatus,
                        workIn: it.workIn,
                        inboundShipment: it.inboundShipment,
                        inboundSeq: it.inboundSeq,
                        externalTrucker: it.externalTrucker,
                        loadRemark: it.loadRemark,
                        moveInBy: it.moveInBy,
                        driverPh: it.driverPh,
                        driverLP: it.driverLP,
                        containerNo: it.containerNo,
                        ciDate: it.ciDate,
                        apptDate: it.apptDate,
                      },
                    ).then((data) => {
                        // result.push(data);
                        // resolve(data);
                        it.errorMsg = data;
                        resolve(it)
                      }).catch((err) => {
                        // result.push(err.messages.join(';'));
                        // resolve(err);
                        it.errorMsg = err.messages.join(';');
                        resolve(it)
                      });
                  });
                }).value();
                Promise.all(allApiCalls).then((results) => {
                  const resultData = [];
                  _(results)
                    .each(it => resultData.push(it));
                    this.$store.commit("updateInbound", resultData);
                    this.updateItems(this.getInboundsList);
                    this.viewFilter.errorMsg = true;
                    this.edit = getInitEdit();
                    this.notifyActive = true;
                    const hasError = _(results).filter((it) => it.errorMsg != null);
                    if (hasError.length == 0)
                    {
                      this.notifyMessage = "Below containers have been updated!"
                      
                    }
                    else
                    {
                      this.notifyMessage = "Some of the items have not been saved , please check error message to learn detial! "
                    }
                    
                    
                });
    },
    saveApptC()
    {
      const editItem = this.items.filter(it  => this.hasBeenChanged(it));
        var result = [];
        const allApiCalls = _(editItem).chain().map((it) => {
                  return new Promise((resolve) => {
                    //api.post(
                    newAPIPost(
                      '/api/w/fsi/WebSaveInbound',
                      {
                        mode: 'APPTC',
                        username : this.getUserProfile.username,
                        apptNo: it.apptNo,
                        apptSeq: it.apptSeq,
                        inboundShipment : it.inboundShipment,
                        inboundStatus: it.inboundStatus,
                        checkIn: 'W',
                        inboundSeq: it.inboundSeq,
                        moveInBy: it.moveInBy,
                        driverPh: it.driverPh,
                        driverLP: it.driverLP,
                        driverId: it.driverId,
                        containerNo: it.containerNo,
                        ciDate: it.ciDate,
                        loadRemark: it.loadRemark,
                      },
                    ).then((data) => {
                        // result.push(data);
                        // resolve(data);
                        it.errorMsg = data;
                        resolve(it)
                      }).catch((err) => {
                        // result.push(err.messages.join(';'));
                        // resolve(err);
                        it.errorMsg = err.messages.join(';');
                        resolve(it)
                      });
   
   
                      this.saveCheckInRequest.receivingWindows = it.receivingWindows 
                      this.saveCheckInRequest.checkIn = "W"
                      this.saveCheckInRequest.username = this.getUserProfile.username
                      this.saveCheckInRequest.inboundSeq = it.inboundSeq
                      this.saveCheckInRequest.inboundShipment = it.inboundShipment
                      this.saveCheckInRequest.inboundStatus = it.inboundStatus
                      this.saveCheckInRequest.block = it.block
                      this.saveCheckInRequest.apptNo = it.apptNo
                      this.saveCheckInRequest.apptDate = it.apptDate
                      this.saveCheckInRequest.apptDateTime = it.apptDate
                      this.saveCheckInRequest.ciDate = it.ciDate
                      this.saveCheckInRequest.moveInBy = it.moveInBy
                      this.saveCheckInRequest.driverPh = it.driverPh
                      this.saveCheckInRequest.driverLP = it.driverLP
                      this.saveCheckInRequest.containerNo = it.containerNo
                      this.saveCheckInRequest.externalTrucker = it.externalTrucker


                      //api.post('/api/w/sqs/send', 
                      newAPIPost('/api/w/sqs/send', 
                        {
                          cmd: "SAVE_CHECKIN",
                          payload: JSON.stringify(this.saveCheckInRequest)
                        }
                      )

                  });
                }).value();
                Promise.all(allApiCalls).then((results) => {
                  const resultData = [];
                  _(results)
                    .each(it => resultData.push(it));
                    this.$store.commit("updateInbound", resultData);
                    this.updateItems(this.getInboundsList, true);
                    this.viewFilter.errorMsg = true;
                    this.edit = getInitEdit();
                    this.notifyActive = true;
                    const hasError = _(results).filter((it) => it.errorMsg != null);
                    if (hasError.length == 0)
                    {
                      this.notifyMessage = "Below containers have been updated!"
                      
                    }
                    else
                    {
                      this.notifyMessage = "Some of the items have not been saved , please check error message to learn detial! "
                    }
                    
                    
                });
    },
    saveApptB()
    {
      const editItem = this.items.filter(it  => this.hasBeenChanged(it));
        var result = [];
        const allApiCalls = _(editItem).chain().map((it) => {
                  return new Promise((resolve) => {
                    //api.post(
                    newAPIPost(
                      '/api/w/fsi/WebSaveInbound',
                      {
                        mode: 'APPTB',
                        username : this.getUserProfile.username,
                        apptNo: it.apptNo,
                        apptSeq: it.apptSeq,
                        inboundShipment : it.inboundShipment,
                        inboundStatus: it.inboundStatus,
                        inboundSeq: it.inboundSeq,
                        bol: it. bol,
                        bolWT: it.bolWT,
                        bolScan: it.bolScan,
                        bolGW: it.bolGW,
                        bolTW: it.bolTW,
                        bolNW: it.bolNW,
                        loadRemark: it.loadRemark,
                      },
                    ).then((data) => {
                        // result.push(data);
                        // resolve(data);
                        it.errorMsg = data;
                        resolve(it)
                      }).catch((err) => {
                        // result.push(err.messages.join(';'));
                        // resolve(err);
                        it.errorMsg = err.messages.join(';');
                        resolve(it)
                      });
                  });
                }).value();
                Promise.all(allApiCalls).then((results) => {
                  const resultData = [];
                  _(results)
                    .each(it => resultData.push(it));
                    this.$store.commit("updateInbound", resultData);
                    this.updateItems(this.getInboundsList, true);
                    this.viewFilter.errorMsg = true;
                    this.edit = getInitEdit();
                    this.notifyActive = true;
                    const hasError = _(results).filter((it) => it.errorMsg != null);
                    if (hasError.length == 0)
                    {
                      this.notifyMessage = "Below containers have been updated!"
                      
                    }
                    else
                    {
                      this.notifyMessage = "Some of the items have not been saved , please check error message to learn detial! "
                    }
                    
                    
                });
    },
    saveApptS()
    {
      const editItem = this.items.filter(it  => this.hasBeenChanged(it));
        var result = [];
        const allApiCalls = _(editItem).chain().map((it) => {
                  return new Promise((resolve) => {
                    //api.post(
                    newAPIPost(
                      '/api/w/fsi/WebSaveInbound',
                      {
                        mode: 'APPTS',
                        username : this.getUserProfile.username,
                        apptNo: it.apptNo,
                        apptSeq: it.apptSeq,
                        inboundShipment : it.inboundShipment,
                        inboundStatus: it.inboundStatus,
                        inboundSeq: it.inboundSeq,
                        scaleCalled : it.scaleCalled,
                        callTime: it.callTime,
                        loadRemark: it.loadRemark,
                      },
                    ).then((data) => {
                        // result.push(data);
                        // resolve(data);
                        it.errorMsg = data;
                        resolve(it)
                      }).catch((err) => {
                        // result.push(err.messages.join(';'));
                        // resolve(err);
                        it.errorMsg = err.messages.join(';');
                        resolve(it)
                      });
                  });
                }).value();
                Promise.all(allApiCalls).then((results) => {
                  const resultData = [];
                  _(results)
                    .each(it => resultData.push(it));
                    this.$store.commit("updateInbound", resultData);
                    this.updateItems(this.getInboundsList, true);
                    this.viewFilter.errorMsg = true;
                    this.edit = getInitEdit();
                    this.notifyActive = true;
                    const hasError = _(results).filter((it) => it.errorMsg != null);
                    if (hasError.length == 0)
                    {
                      this.notifyMessage = "Below containers have been updated!"
                      
                    }
                    else
                    {
                      this.notifyMessage = "Some of the items have not been saved , please check error message to learn detial! "
                    }
                    
                    
                });
    },
    saveApptGW(){
      const editItem = this.items.filter(it  => this.hasBeenChanged(it));
      
      var hasError = false;
      var hasWarning = false;
      editItem.forEach((it) => {
            // if (it.containerNo == null )
            // {
            //   it.gwWarning = 'Trailer is required';
            //   hasWarning = true;
            // }

            if (it.ibs_type == "Wal Hawaii" && (it.gwYgNo == null ) )
            {
              it.gwygError = 'Yard Goat is requreid!';
              hasError = true;
            }
            if (hasError == false)
            {
              var gwControl = null;
              const masterData = this.getMasterDataByGroup('WEIGHT_CONTROL');
              if (masterData.length != 0)
              {
                masterData.forEach((it) => {
                if (it.id == 'GW') gwControl = Number(it.diffTolerance);
              });
              }
              if (it.bolGW != null && it.bolGW != '')
              {
                const diff = Number(it.vgmWeight) - Number(it.bolGW);
                if (diff > gwControl) 
                {
                  it.gwWarning = 'Gross Weight is over the tolerance!';
                  hasWarning = true;
                }
              }
            }
          });
        if (hasError == true) return
        if (hasWarning)
        {
          this.$buefy.dialog.confirm({
                    title: 'Weight Control Warning',
                    message: 'Some items has weight differnet, you can click cancel to review.',
                    confirmText: 'Confirm',
                    type: 'is-danger',
                    hasIcon: true,
                    onConfirm: () => 
          {
        const allApiCalls = _(editItem).chain().map((it) => {
                  return new Promise((resolve) => {
                    //api.post(
                    newAPIPost(
                      '/api/w/fsi/WebSaveInbound',
                      {
                        mode: 'APPTGW',
                        username : this.getUserProfile.username,
                        apptNo: it.apptNo,
                        apptSeq: it.apptSeq,
                        inboundShipment : it.inboundShipment,
                        inboundStatus: it.inboundStatus,
                        inboundSeq: it.inboundSeq,
                        gwStation: it.gwStation,
                        containerNo: it.containerNo,
                        vgmWeight: it.vgmWeight,
                        gwDate: it.gwDate,
                        gwDateWeb: it.gwDateWeb,
                        // gwTime: it.gwTime,
                        gwYgNo: it.gwYgNo,
                        gwYgWeight: it.gwYgWeight,
                        loadRemark: it.loadRemark,
                        // ticketPrefix: 'FI' + dateFormat.getLocalDateNumber(moment().toDate()),
                        ticketPrefix: it.receivingWindows == '185' || it.receivingWindows == '187' || it.receivingWindows == '202' ? 'FI' : it.receivingWindows == '186' || it.receivingWindows == '188' || it.receivingWindows == '201' || it.receivingWindows == '203' ? 'WI' : 'TBD',
                        //it.receivingWindows == '185' ? 'FI' : 'WI',
                        driverLP: it.driverLP,
                        originalGW: (it.originalGW && it.originalGW != "")? parseInt(it.originalGW) : 0,
                      },
                    ).then((data) => {
                        // result.push(data);
                        // resolve(data);
                        // it.errorMsg = data;
                        it.scaleTicket = data;
                        resolve(it)
                      }).catch((err) => {
                        // result.push(err.messages.join(';'));
                        // resolve(err);
                        it.errorMsg = err.messages.join(';');
                        resolve(it)
                      });
                  });
                }).value();
                Promise.all(allApiCalls).then((results) => {
                  const resultData = [];
                  _(results)
                    .each(it => resultData.push(it));
                    this.$store.commit("updateInbound", resultData);
                    this.updateItems(this.getInboundsList, true);
                    this.viewFilter.errorMsg = true;
                    this.edit = getInitEdit();
                    this.edit.preSelect = true;
                    this.isAblePrint = true;
                    this.notifyActive = true;
                    const hasError = _(results).filter((it) => it.errorMsg != null);
                    if (hasError.length == 0)
                    {
                      this.notifyMessage = "Below containers have been updated!"
                      
                    }
                    else
                    {
                      this.notifyMessage = "Some of the items have not been saved , please check error message to learn detial! "
                    }
                    
                    
                });
            
            }
                })
        }
        else
        {
        const allApiCalls = _(editItem).chain().map((it) => {
                  return new Promise((resolve) => {
                    //api.post(
                    newAPIPost(
                      '/api/w/fsi/WebSaveInbound',
                      {
                        mode: 'APPTGW',
                        username : this.getUserProfile.username,
                        apptNo: it.apptNo,
                        apptSeq: it.apptSeq,
                        inboundShipment : it.inboundShipment,
                        inboundStatus: it.inboundStatus,
                        inboundSeq: it.inboundSeq,
                        gwStation: it.gwStation,
                        containerNo: it.containerNo,
                        vgmWeight: it.vgmWeight,
                        gwDate: it.gwDate,
                        gwDateWeb: it.gwDateWeb,
                        // gwTime: it.gwTime,
                        gwYgNo: it.gwYgNo,
                        gwYgWeight: it.gwYgWeight,
                        loadRemark: it.loadRemark,
                        // ticketPrefix: 'FI' + dateFormat.getLocalDateNumber(moment().toDate()),
                         //ticketPrefix: it.receivingWindows == '185' ? 'FI' : 'WI',
                         ticketPrefix: it.receivingWindows == '185' || it.receivingWindows == '187' || it.receivingWindows == '202' ? 'FI' : it.receivingWindows == '186' || it.receivingWindows == '188' || it.receivingWindows == '201' || it.receivingWindows == '203' ? 'WI' : 'TBD',
                        driverLP: it.driverLP,
                        originalGW: (it.originalGW && it.originalGW != "")? parseInt(it.originalGW) : 0,
                      },
                    ).then((data) => {
                        // result.push(data);
                        // resolve(data);
                        // it.errorMsg = data;
                        it.scaleTicket = data;
                        resolve(it)
                      }).catch((err) => {
                        // result.push(err.messages.join(';'));
                        // resolve(err);
                        it.errorMsg = err.messages.join(';');
                        resolve(it)
                      });
                  });
                }).value();
                Promise.all(allApiCalls).then((results) => {
                  const resultData = [];
                  _(results)
                    .each(it => resultData.push(it));
                    this.$store.commit("updateInbound", resultData);
                    this.updateItems(this.getInboundsList, true);
                    this.viewFilter.errorMsg = true;
                    this.edit = getInitEdit();
                    this.edit.preSelect = true;
                    this.isAblePrint = true;
                    this.notifyActive = true;
                    const hasError = _(results).filter((it) => it.errorMsg != null);
                    if (hasError.length == 0)
                    {
                      this.notifyMessage = "Below containers have been updated!"
                      
                    }
                    else
                    {
                      this.notifyMessage = "Some of the items have not been saved , please check error message to learn detial! "
                    }
                    
                    
                });
        }
        
    },
    saveApptTW(){
      const editItem = this.items.filter(it  => this.hasBeenChanged(it));
        var result = [];
        var hasError = false;
        var hasWarning = false;
        var hasNagtiveW = false;
        var hasZeroW = false;

        editItem.forEach((it) => {
            console.log(`item in save tw: ${JSON.stringify(it)}`);
            if (it.tareWeight == null || it.tareWeight == '')
            {
              it.twScaleError = 'TW scale weight is required!';
              hasError = true;
            }
            else
            {
              if (Number(it.tareWeight) == 'NaN')
              {
                it.twScaleError = 'Please input a number!';
                hasError = true;
              }
              
            }
            
            // if (it.ibs_type == "Wal Hawaii")
            // {
            //   if (it.twYgNo == null)
            //   {
            //     it.twygError = 'Yard Goat is requreid for the walmart Hawaii load!';
            //     hasError = true;
            //   }
            //   if (it.plasticCount == null || it.plasticCount == '')
            //   {
            //     it.plCtError = 'Plastic count is requried for Walmart Hawaii load!';
            //     hasError = true;
            //   }
            //   else
            //   {
            //     if (Number(it.tareWeight) == 'NaN')
            //     {
            //       it.twScaleError = 'Please input a number!';
            //       hasError = true;
            //     }
            //   }
            //   if (it.plasticWeight == null || it.plasticWeight == '')
            //   {
            //     it.plWeError = 'Plastic count is requried for Walmart Hawaii load!';
            //     hasError = true;
            //   }
            //   else
            //   {
            //     if (Number(it.tareWeight) == 'NaN')
            //     {
            //       it.twScaleError = 'Please input a number!';
            //       hasError = true;
            //     }
            //   }
            //   if (it.palletCount == null || it.palletCount == '')
            //   {
            //     it.paCtError = 'Plastic count is requried for Walmart Hawaii load!';
            //     hasError = true;
            //   }
            //   else
            //   {
            //     if (Number(it.tareWeight) == 'NaN')
            //     {
            //       it.twScaleError = 'Please input a number!';
            //       hasError = true;
            //     }
            //   }
            //   if (it.palletWeight == null || it.palletWeight == '')
            //   {
            //     it.paWeError = 'Plastic count is requried for Walmart Hawaii load!';
            //     hasError = true;
            //   }
            //   else
            //   {
            //     if (Number(it.tareWeight) == 'NaN')
            //     {
            //       it.twScaleError = 'Please input a number!';
            //       hasError = true;
            //     }
            //   }
            // }

            //apply the below for all inbound cases
            if (it.twYgNo == null)
            {
              it.twygError = 'Yard Goat is requreid for the inbound load!';
              hasError = true;
            }
            if (it.plasticCount == null || it.plasticCount == '')
            {
              //it.plCtError = 'Plastic count is requried for the inbound load!';
              //hasError = true;
              it.plasticCount = '0';
            }
            else
            {
              if (Number(it.tareWeight) == 'NaN')
              {
                it.twScaleError = 'Please input a number!';
                hasError = true;
              }
            }
            if (it.plasticWeight == null || it.plasticWeight == '')
            {
              //it.plWeError = 'Plastic count is requried for the inbound load!';
              //hasError = true;
              it.plasticWeight = '0';
            }
            else
            {
              if (Number(it.tareWeight) == 'NaN')
              {
                it.twScaleError = 'Please input a number!';
                hasError = true;
              }
            }
            if (it.palletCount == null || it.palletCount == '')
            {
              //it.paCtError = 'Plastic count is requried for the inbound load!';
              //hasError = true;
              it.palletCount = '0';
            }
            else
            {
              if (Number(it.tareWeight) == 'NaN')
              {
                it.twScaleError = 'Please input a number!';
                hasError = true;
              }
            }
            if (it.palletWeight == null || it.palletWeight == '')
            {
              //it.paWeError = 'Plastic count is requried for the inbound load!';
              //hasError = true;
              it.palletWeight = '0';
            }
            else
            {
              if (Number(it.tareWeight) == 'NaN')
              {
                it.twScaleError = 'Please input a number!';
                hasError = true;
              }
            }
           

            // if (it.ibs_type == "Target")
            // {
            //   if (it.twYgNo == null)
            //   {
            //     it.twygError = 'Yard Goat is requreid for the Target load!';
            //     hasError = true;
            //   }
            // }
            if (hasError == false)
            {
              //if (it.ibs_type == "Target")
              //{
              //  it.weight = (Number(it.vgmWeight) - Number(it.gwYgWeight) - (Number(it.tareWeight) - Number(it.twYgWeight))).toString();
              //}  
              //else if (it.ibs_type == "Wal Hawaii"){
              //  it.weight = (Number(it.vgmWeight) - Number(it.gwYgWeight) - (Number(it.tareWeight) - Number(it.twYgWeight)) - Number(it.plasticWeight) - Number(it.palletWeight)).toString();
              //}
              //else
              //{
              //  it.weight = (Number(it.vgmWeight) - Number(it.tareWeight)).toString();
              //}
              
              //it.weight = (Number(it.vgmWeight) - Number(it.gwYgWeight) - (Number(it.tareWeight) - Number(it.twYgWeight)) - Number(it.plasticWeight) - Number(it.palletWeight)).toString();
              //it.wetNet = (Number(it.wetNet) - Number(it.plasticWeight) - Number(it.palletWeight)).toString();
              //it.dryNet = (Number(it.dryNet) - Number(it.plasticWeight) - Number(it.palletWeight)).toString();
              console.log(`wetNet: ${it.wetNet}`);
              console.log(`dryNet: ${it.dryNet}`);
              if (Number(it.weight) < 0)
              {
                hasNagtiveW = true;
              }
              if (Number(it.weight) == 0)
              {
                hasZeroW = true;
              }

              var twControl = null;
              var nwControl = null;
              const masterData = this.getMasterDataByGroup('WEIGHT_CONTROL');
              if (masterData.length != 0)
              {
                masterData.forEach((it) => {
                if (it.id == 'TW') twControl = Number(it.diffTolerance);
                if (it.id == 'NW') nwControl = Number(it.diffTolerance);
              });
              }
              if (it.bolTW != null && it.bolTW != '')
              {
                const diff = Number(it.tareWeight) - Number(it.bolTW);
                if (diff > twControl) 
                {
                  it.twWarning = 'Tare Weight is over the tolerance!';
                  it.weightDifferent = 'X'
                  hasWarning = true;
                }
                
              }
              if (it.bolNW != null && it.bolNW != '')
              {
                const diff = Number(it.weight) - Number(it.bolNW);
                if (diff > nwControl) 
                {
                  it.netWarning = 'Net Weight is over the tolerance!';
                  hasWarning = true;
                }
              }
            }
          });
        if (hasError == true) return
        if (hasNagtiveW == true)
        {
          this.$buefy.notification.open({
                    duration: 5000,
                    message: `Items contain negative weight , please check again!`,
                    position: 'is-top-right',
                    type: 'is-danger',
                    hasIcon: true
                })
        return
        }
        if (hasZeroW == true)
        {
          this.$buefy.notification.open({
                    duration: 5000,
                    message: `Net weight cannot be zero , please check again!`,
                    position: 'is-top-right',
                    type: 'is-danger',
                    hasIcon: true
                })
        return

        }        

        
        if (hasWarning)
        {
          this.$buefy.dialog.confirm({
                    title: 'Weight Control Warning',
                    message: 'Some items has weight differnet, you can click cancel to review.',
                    confirmText: 'Confirm',
                    type: 'is-danger',
                    hasIcon: true,
                    onConfirm: () => 
          {
                      var result = [];
            const allApiCalls = _(editItem).chain().map((it) => {
                  return new Promise((resolve) => {
                    //api.post(
                    newAPIPost(
                      '/api/w/fsi/WebSaveInbound',
                      {
                        mode: 'APPTTW',
                        username : this.getUserProfile.username,
                        apptNo: it.apptNo,
                        apptSeq: it.apptSeq,
                        inboundShipment : it.inboundShipment,
                        inboundStatus: it.inboundStatus,
                        inboundSeq: it.inboundSeq,
                        twStation: it.twStation,
                        tareWeight: it.tareWeight,
                        twDate: it.twDate,
                        twDateWeb: it.twDateWeb,
                        // twTime: it.twTime,
                        weight: it.weight,
                        totalHours: it.totalHours,
                        twYgNo: it.twYgNo,
                        twYgWeight: it.twYgWeight,
                        plasticCount: it.plasticCount,
                        palletCount: it.palletCount,
                        plasticWeight: it.plasticWeight,
                        palletWeight: it.palletWeight,
                        weightDifferent: it.weightDifferent,
                        bales: it.bales,
                        looseCount: it.looseCount,
                        qcIssue: it.qcIssue,
                        upgradeSuggestion: it.upgradeSuggestion,
                        loadRemark: it.loadRemark,
                        avm: it.avm,
                        moistureDedInLBS: it.moistureDedInLBS,
                        moistureDedInPercent: it.moistureDedInPercent,
                        wetNet: it.wetNet,
                        dryNet: it.dryNet,
                        originalGW: (it.originalGW && it.originalGW != "")? parseInt(it.originalGW) : 0,
                        originalTW: (it.originalTW && it.originalTW != "")? parseInt(it.originalTW) : 0,
                      },
                    ).then((data) => {
                        // result.push(data);
                        // resolve(data);
                        it.errorMsg = data;
                        resolve(it)
                      }).catch((err) => {
                        // result.push(err.messages.join(';'));
                        // resolve(err);
                        it.errorMsg = err.messages.join(';');
                        resolve(it)
                      });
                  });
                }).value();
                Promise.all(allApiCalls).then((results) => {
                  const resultData = [];
                  _(results)
                    .each(it => resultData.push(it));
                    this.$store.commit("updateInbound", resultData);
                    this.updateItems(this.getInboundsList, true);
                    this.viewFilter.errorMsg = true;
                    this.edit = getInitEdit();
                    this.edit.preSelect = true;
                    this.isAblePrint = true;
                    this.notifyActive = true;
                    const hasError = _(results).filter((it) => it.errorMsg != null);
                    if (hasError.length == 0)
                    {
                      this.notifyMessage = "Below containers have been updated!"
                      
                    }
                    else
                    {
                      this.notifyMessage = "Some of the items have not been saved , please check error message to learn detial! "
                    }
                    
                    
                });
                    }
                })
        }
        else
        {
            var result = [];
            const allApiCalls = _(editItem).chain().map((it) => {
                  return new Promise((resolve) => {
                    //api.post(
                    newAPIPost(
                      '/api/w/fsi/WebSaveInbound',
                      {
                        mode: 'APPTTW',
                        username : this.getUserProfile.username,
                        apptNo: it.apptNo,
                        apptSeq: it.apptSeq,
                        inboundShipment : it.inboundShipment,
                        inboundStatus: it.inboundStatus,
                        inboundSeq: it.inboundSeq,
                        twStation: it.twStation,
                        tareWeight: it.tareWeight,
                        twDate: it.twDate,
                        twDateWeb: it.twDateWeb,
                        // twTime: it.twTime,
                        weight: it.weight,
                        totalHours: it.totalHours,
                        twYgNo: it.twYgNo,
                        twYgWeight: it.twYgWeight,
                        plasticCount: it.plasticCount,
                        palletCount: it.palletCount,
                        plasticWeight: it.plasticWeight,
                        palletWeight: it.palletWeight,
                        weightDifferent: it.weightDifferent,
                        bales: it.bales,
                        looseCount: it.looseCount,
                        qcIssue: it.qcIssue,
                        upgradeSuggestion: it.upgradeSuggestion,
                        loadRemark: it.loadRemark,
                        avm: it.avm,
                        moistureDedInLBS: it.moistureDedInLBS,
                        moistureDedInPercent: it.moistureDedInPercent,
                        wetNet: it.wetNet,
                        dryNet: it.dryNet,
                        originalGW: (it.originalGW && it.originalGW != "")? parseInt(it.originalGW) : 0,
                        originalTW: (it.originalTW && it.originalTW != "")? parseInt(it.originalTW) : 0,
                      },
                    ).then((data) => {
                        // result.push(data);
                        // resolve(data);
                        it.errorMsg = data;
                        resolve(it)
                      }).catch((err) => {
                        // result.push(err.messages.join(';'));
                        // resolve(err);
                        it.errorMsg = err.messages.join(';');
                        resolve(it)
                      });
                  });
                }).value();
                Promise.all(allApiCalls).then((results) => {
                  const resultData = [];
                  _(results)
                    .each(it => resultData.push(it));
                    this.$store.commit("updateInbound", resultData);
                    this.updateItems(this.getInboundsList, true);
                    this.viewFilter.errorMsg = true;
                    this.edit = getInitEdit();
                    this.edit.preSelect = true;
                    this.isAblePrint = true;
                    this.notifyActive = true;
                    const hasError = _(results).filter((it) => it.errorMsg != null);
                    if (hasError.length == 0)
                    {
                      this.notifyMessage = "Below containers have been updated!"
                      
                    }
                    else
                    {
                      this.notifyMessage = "Some of the items have not been saved , please check error message to learn detial! "
                    }
                    
                    
                });
        }
        
        
        
    },


    saveApptTM()
    {
      const editItem = this.items.filter(it  => this.hasBeenChanged(it));
        var result = [];
        const allApiCalls = _(editItem).chain().map((it) => {
                  return new Promise((resolve) => {
                    //api.post(
                    newAPIPost(
                      '/api/w/fsi/WebSaveInbound',
                      {
                        mode: 'APPTTM',
                        username : this.getUserProfile.username,
                        apptNo: it.apptNo,
                        apptSeq: it.apptSeq,
                        inboundShipment : it.inboundShipment,
                        inboundStatus: it.inboundStatus,
                        inboundSeq: it.inboundSeq,
                        bales: it.bales,
                        upgradeSuggestion: it.upgradeSuggestion,
                        upgradeBales: it.upgradeBales,
                        scanWt: it.scanWt,
                      },
                    ).then((data) => {
                        it.errorMsg = data;
                        resolve(it)
                      }).catch((err) => {
                        it.errorMsg = err.messages.join(';');
                        resolve(it)
                      });
                  });
                }).value();
                Promise.all(allApiCalls).then((results) => {
                  const resultData = [];
                  _(results)
                    .each(it => resultData.push(it));
                    this.$store.commit("updateInbound", resultData);
                    this.updateItems(this.getInboundsList, true);
                    this.viewFilter.errorMsg = true;
                    this.edit = getInitEdit();
                    this.notifyActive = true;
                    const hasError = _(results).filter((it) => it.errorMsg != null);
                    if (hasError.length == 0)
                    {
                      this.notifyMessage = "Below containers have been updated!"
                      
                    }
                    else
                    {
                      this.notifyMessage = "Some of the items have not been saved , please check error message to learn detial! "
                    }
                    
                    
                });
    },

    async doSearch(id) {
      console.log(this.edit.mode);
      this.isdisableSend = true;
      this.isdisablephoto = true;
      this.$store.commit("clearApiError");
      this.notifyActive = false;
      this.notifyMessage = null;
      this.isAblePrint = false;
      if (this.searchRequest.transloadingYard == null || this.searchRequest.transloadingYard === '')
      {
        this.$buefy.notification.open({
                    duration: 5000,
                    message: `Transloading Yard is required!`,
                    position: 'is-top-right',
                    type: 'is-danger',
                    hasIcon: true
                })
        return
      }
      
      if (this.searchRequest.receivingWindows == null || this.searchRequest.receivingWindows === '')
      {
        this.$buefy.notification.open({
                    duration: 5000,
                    message: `Receving Windows is required!`,
                    position: 'is-top-right',
                    type: 'is-danger',
                    hasIcon: true
                })
        return
      }

      // if (this.searchRequest.dockType == null || this.searchRequest.dockType == '')
      // {
      //   this.$buefy.notification.open({
      //               duration: 5000,
      //               message: `Dock Type is required!`,
      //               position: 'is-top-right',
      //               type: 'is-danger',
      //               hasIcon: true
      //           })
      //   return
      // }

  
      if (this.searchRequest.inboundShipment == null || this.searchRequest.inboundShipment == '')
      {
         if (this.searchRequest.apptDate == null || this.searchRequest.apptDate === '')
         {
            this.$buefy.notification.open({
                    duration: 5000,
                    message: `Appt Date is required!`,
                    position: 'is-top-right',
                    type: 'is-danger',
                    hasIcon: true
                })
            return
         }
      }
    
      
      //id = "APPTU"
      for (const el of this.trimOption) {
        this.searchRequest[el] = this.trimTool(this.searchRequest[el]);
      }
      var req = this.searchRequest;
      if (id == 'APPTS') 
      {
        this.sumItems = [];
        req = {
          transloadingYard: this.searchRequest.transloadingYard,
          receivingWindows: this.searchRequest.receivingWindows,
          apptDate: this.searchRequest.apptDate,
        }
      }
      this.items = [];
      if (id == '0')
      {
        this.isAblePrint = true;
        this.viewFilter = getInitView();
        this.edit = getInitEdit();
      }
      if (id == 'APPTG')
      {
        
        this.viewFilter = getGenerateView(); 
        this.edit = generateEdit();
      }
      if (id =='APPTU')
      {
        this.viewFilter = getUpdateView(); 
        this.edit = updateEdit();
      }
      await this.$store.dispatch("inboundsList", req);
     
      //this.active = false;
      this.active = true;
    },
    clearSearch() {
      _(this.$el.querySelectorAll('.searchPanel .md-field button.md-input-action.md-clear'))
          .each((it) => {
            it.click();
            this.searchRequest = getInitSearch();
          });
      this.$nextTick(() => {
          
          this.searchRequest.salesOffice = this.getUserProfile.defaultSalesOffice;
          // this.searchRequest.receivingWindows = this.getUserProfile.recWindow;
          this.items = this.getInboundsList;
          this.updateItems(this.getInboundsList);
          this.edit = getInitEdit();
          this.isdisableSend = true;
          this.isdisablephoto = true;
        });
      
    },
    getDisplay(group, tagId) {
      if (!tagId) {
        return "";
      }
      return this.getMasterDataName(group, tagId) || this.tagId;
    },
    overGWMinMax(item) {
       const gw = (item.vgmWeight == null)? item.vgmWeight : parseInt(item.vgmWeight);
       console.log(`gw: ${gw}`);
       return gw < 48000 || gw > 85000;
    },
    overTWMinMax(item) {
       const tw = (item.tareWeight == null)? item.tareWeight : parseInt(item.tareWeight);
       return tw < 25000 || tw > 35000;
    },
    overNWMinMax(item) {
       const nw = (item.weight == null)? item.weight : parseInt(item.weight);
       return nw < 25000 || nw > 50000;
    },
   async  checkIBS(item){
      console.log(`checkIBS: ${JSON.stringify(item)}`)
      item.ibsError = null;
      const lhs = _(this.getInboundsList)
          .find(it => it.apptNo === item.apptNo);
      if (lhs.inboundShipment == item.inboundShipment) return
      //Originally QAS and PRD do not have below change, so
      //just comment out and leave in the code for record
      //just in case - Alex 10/11/2024
      // if (item.dockType != item.ibsDockType)
      // { 
      //   item.ibsError = 'IBS docktype not equal to appt docktype!';
      //   return
      // }
      if (item.inboundShipment == null || item.inboundShipment == '')
      {
        
        if (lhs.inboundShipment == null) 
        {
          item.inboundShipment = null;
          return
        }
        if (item.inboundStatus == 'C')
        {
          item.ibsError = 'IBS can not be deleted if status is checked in!';
          return
        }
       
          return
      }
      item.loading = true;
      //api.post("/api/w/fsi/WebSearchIbs", {
      newAPIPost("/api/w/fsi/WebSearchIbs", {
        inboundShipment: item.inboundShipment,
        dockType: item.dockType,
        apptDate: item.apptDate,
      })
      .then((res) => {
        this.$store.commit('clearApiError');
        item.ibsError = null;
        item.loading = false;
          })
      .catch((err) => {
        this.$store.commit('clearApiError');
        item.loading = false;
        item.ibsError = err.messages.join(';');
      
                      });
    },
    async  generateView(receivingWindows,apptDate,dockType, res ){
      this.searchRequest.receivingWindows = receivingWindows;
      this.searchRequest.apptDate = apptDate;
      this.searchRequest.dockType = dockType
      if (res == 'X')
      {
        this.notifyMessage = 'The Appoinment for the day have been genrated before!'
        this.notifyActive = true;
      }
      this.viewFilter = getGenerateView(); 
      // this.edit = true;
      this.edit = generateEdit();
      this.doSearch('APPTG');
    },
    async loadCreateDriver(shortId, driverMobile, defaultPlateNum, trailernum, apptNo)
    {
      this.drivers.push({
            id: shortId,
            name: driverMobile,
            plate: defaultPlateNum,
            trail: trailernum,
      });
      var selectedItem = _(this.items).find(it => it.apptNo === apptNo);
      selectedItem.moveInBy = shortId;
      selectedItem.driverPh = driverMobile;
      selectedItem.driverLP = defaultPlateNum;
      // selectedItem.containerNo = trailernum;
    },
    async loadFSICreateDriver(id, fullname, mobile, tractornum, trailernum, apptNo) {
          console.log("id " + id + " fullname: " + fullname + " mobile: " + mobile + " trailernum: " + trailernum + " tractornum: " + tractornum + " apptNo: " + apptNo);
          this.drivers.push({
            id: id,
            name: fullname + " / " + mobile,
            mobile: mobile,
            trail: trailernum,
            tractorNum: tractornum,
          });
          //filteredRows.filter((it) => {it.selected == true}).forEach((it) => {
            // _(this.filteredRows).forEach((it) => {
            //  if (it.apptNo === apptNo)
            //  {
            //     it.moveInBy = fullname;
            //     it.driverPh = mobile;
            //     it.driverLP = trailernum;
            //  }
            console.log(`drivers list after updated: ${JSON.stringify(this.drivers)}`);
            var selectedItem = _(this.items).find(it => it.apptNo === apptNo);
            if (selectedItem != null)
            {
               console.log(`selected Item: ${JSON.stringify(selectedItem)}`);
               selectedItem.moveInBy = id;
               selectedItem.driverPh = mobile;
               selectedItem.driverLP = trailernum;
            }
            console.log(`filterrows: ${JSON.stringify(this.filteredRows)}`);
          //});
          // var selectedItem = _(this.items).find(it => it.apptNo === apptNo);
          // selectedItem.moveInBy = driverfullname;
          // selectedItem.driverPh = mobile;
          // selectedItem.driverLP = trailernum;
    },
    async loadBOL(bol, scan, inboundShipment)
    {
      var selectedItem = _(this.items).find(it => it.inboundShipment === inboundShipment);
      selectedItem.bol = bol;
      selectedItem.bolScan = scan;
      console.log("bolScan: " + scan);
    },
    async  updateView(receivingWindows,apptDate,dockType ){
      this.searchRequest.receivingWindows = receivingWindows;
      this.searchRequest.apptDate = apptDate;
      this.searchRequest.dockType = null;
      this.viewFilter = getUpdateView(); 
      this.edit = updateEdit();
      this.doSearch('APPTU');
    },
    //async setGrossWeight(scale , date, weight, ygNo, ygWeight){
    async setGrossWeight(scale , originalgw){
      const change = this.getSelectedItems[0];
      // change.vgmWeight = weight;
      // change.gwTime = item.time;
      change.gwStation = scale;
      change.originalGW = originalgw;
      console.log(`selectitem: ${JSON.stringify(change)} main items: ${JSON.stringify(this.items)}`);
      // change.gwDate = date;
      this.refreshSelectList();
    },
    async setTareWeight(scale, avm, moistdeductlbs, moistdeductper, wetnet, drynet, originalgw, originaltw, plasticWeight, palletCount, palletWeight) {
      const change = this.getSelectedItems[0];
      //console.log("before change item: " + JSON.stringify(change));
      //console.log("return originalgw: " + originalgw + ", originaltw: " + originaltw);
      change.twStation = scale;
      //change.weight = (Number(change.vgmWeight) - Number(change.tareWeight)).toString();
      const twTime = moment(change.twDate)
      const apptTime = moment(change.apptDate);
      const ciDate = moment(change.ciDate);
      if (apptTime.isAfter(ciDate))
        {
          change.totalHours = twTime.diff(apptTime, 'hours').toString();
        }
        else
        {
          change.totalHours = twTime.diff(ciDate, 'hours').toString();
        }
      change.avm = avm;
      change.moistureDedInLBS = moistdeductlbs;
      change.moistureDedInPercent = moistdeductper;
      change.wetNet = wetnet;
      change.dryNet = drynet; 
      change.weight = wetnet;
      change.originalGW = originalgw;
      change.originalTW = originaltw;
      change.plasticWeight = plasticWeight; 
      change.palletCount = palletCount;
      change.palletWeight = palletWeight;
      this.refreshSelectList();
      //console.log("after change item: " + JSON.stringify(change));
    },
    async  updateSource(item){
      this.items = item;
    },
    getTest()
    {
      return this.test === true;
    },
    genrerateAppt(){
      // this.$refs.InboundFormGenerate.openDialog();
      if (this.searchRequest.transloadingYard == null || this.searchRequest.transloadingYard === '')
      {
        this.$buefy.notification.open({
                    duration: 5000,
                    message: `Transloading Yard is required!`,
                    position: 'is-top-right',
                    type: 'is-danger',
                    hasIcon: true
                })
        return
      }
      
      if (this.searchRequest.receivingWindows == null || this.searchRequest.receivingWindows === '')
      {
        this.$buefy.notification.open({
                    duration: 5000,
                    message: `Receving Windows is required!`,
                    position: 'is-top-right',
                    type: 'is-danger',
                    hasIcon: true
                })
        return
      }
      if (this.searchRequest.apptDate == null || this.searchRequest.apptDate === '')
      {
        this.$buefy.notification.open({
                    duration: 5000,
                    message: `Appt Date is required!`,
                    position: 'is-top-right',
                    type: 'is-danger',
                    hasIcon: true
                })
        return
      }
      if (this.searchRequest.dockType == null || this.searchRequest.dockType == '')
      {
        this.$buefy.notification.open({
                    duration: 5000,
                    message: `Dock type required!`,
                    position: 'is-top-right',
                    type: 'is-danger',
                    hasIcon: true
                })
      return 
      }
      this.items = [];
      var weekday = moment(this.searchRequest.apptDate).day();
      console.log("weekday: " + weekday);

      //generate temmplate appt
      //if (weekday != 6 && weekday != 0)
      if (weekday != 0) 
      {
        if (this.searchRequest.dockType === "Normal")
        {
           console.log("call template appt");
           this.processAppt = true;
           //api.post("/api/w/fsi/WebGenerateTempInbound", {
           newAPIPost("/api/w/fsi/WebGenerateTempInbound", {
           transloadingYard: this.searchRequest.transloadingYard,
           receivingWindows: this.searchRequest.receivingWindows,
           dockType : this.searchRequest.dockType,
           apptDate: dateFormat.getLocalDateOnly(this.searchRequest.apptDate),
           weekDay : moment(this.searchRequest.apptDate).day(),
           })
           .then((res) => {
             this.processAppt = false;
             this.$store.commit('clearApiError');
             this.showDialog = false;
             if (res == 'X')
             {
               this.notifyMessage = 'Appointment data already Exist, please maintain in the update view!'
               this.notifyActive = true;
             }
             else
             {
               this.doSearch('APPTG');
             }
             
           });
        }
        else
        {
           this.processAppt = true;
           //api.post("/api/w/fsi/WebGenerateInbound", {
           newAPIPost("/api/w/fsi/WebGenerateInbound", {
             transloadingYard: this.searchRequest.transloadingYard,
             receivingWindows: this.searchRequest.receivingWindows,
             dockType : this.searchRequest.dockType,
             apptDate: dateFormat.getLocalDateOnly(this.searchRequest.apptDate),
             weekDay : moment(this.searchRequest.apptDate).day(),
           })
           .then((res) => {
              this.processAppt = false;
              this.$store.commit('clearApiError');
              this.showDialog = false;
              if (res == 'X')
              {
                this.notifyMessage = 'Appointment data already Exist, please maintain in the update view!'
                this.notifyActive = true;
              }
              else
              {
                this.doSearch('APPTG');
              }
          });
      
        }
       }
       else
       {
         this.processAppt = true;
         //api.post("/api/w/fsi/WebGenerateInbound", {
         newAPIPost("/api/w/fsi/WebGenerateInbound", {
           transloadingYard: this.searchRequest.transloadingYard,
           receivingWindows: this.searchRequest.receivingWindows,
           dockType : this.searchRequest.dockType,
           apptDate: dateFormat.getLocalDateOnly(this.searchRequest.apptDate),
           weekDay : moment(this.searchRequest.apptDate).day(),
         })
         .then((res) => {
           this.processAppt = false;
           this.$store.commit('clearApiError');
           this.showDialog = false;
           if (res == 'X')
           {
              this.notifyMessage = 'Appointment data already Exist, please maintain in the update view!'
              this.notifyActive = true;
           }
           else
           {
              this.doSearch('APPTG');
           }
         });
       }
      //}
      //   api.post("/api/w/fsi/WebGenerateInbound", {
      //     transloadingYard: this.searchRequest.transloadingYard,
      //     receivingWindows: this.searchRequest.receivingWindows,
      //     dockType : this.searchRequest.dockType,
      //     apptDate: dateFormat.getLocalDateOnly(this.searchRequest.apptDate),
      //     weekDay : moment(this.searchRequest.apptDate).day(),
      //   })
      //   .then((res) => {
      //     this.$store.commit('clearApiError');
      //     this.showDialog = false;
      //     if (res == 'X')
      //     {
      //        this.notifyMessage = 'Appointment data already Exist, please maintain in the update view!'
      //        this.notifyActive = true;
      //     }
      //     else
      //     {
      //        this.doSearch('APPTG');
      //     }
      //   });
    },

    doNothing() {
      return false;
    },

    updateAppt(){
      // this.$refs.InboundFormUpdate.openDialog();
      
      this.doSearch('APPTU');
    },

    walkInAppt() {
      console.log('Walk In');
      this.$refs.WalkInForm.openDialog(null);
    },



    checkInAppt(){
      const editItem = this.items.filter(it  => this.hasBeenChanged(it));
      //const editItem = this.items;
      if (editItem.length != 0)
      {
        this.$buefy.notification.open({
                    duration: 5000,
                    message: `Please save your works first!`,
                    position: 'is-top-right',
                    type: 'is-danger',
                    hasIcon: true
                })
        return
      }
      this.viewFilter = getCheckInView();
      this.edit = checkInEdit();
      this.doSearch('APPTC');
      this.isdisableSend = true;
      this.isdisablephoto = true;
    },
    bolAppt(){
      const editItem = this.items.filter(it  => this.hasBeenChanged(it));
      if (editItem.length != 0)
      {
        this.$buefy.notification.open({
                    duration: 5000,
                    message: `Please save your works first!`,
                    position: 'is-top-right',
                    type: 'is-danger',
                    hasIcon: true
                })
        return
      }
      this.viewFilter = getBolView();
      this.edit = bolEdit();
      this.doSearch('APPTB');
      this.isdisableSend = true;
      this.isdisablephoto = false;
    },
    scaleCallAppt(){
      const editItem = this.items.filter(it  => this.hasBeenChanged(it));
      //this.isdisableSend = false;
      if (editItem.length != 0)
      {
        this.$buefy.notification.open({
                    duration: 5000,
                    message: `Please save your works first!`,
                    position: 'is-top-right',
                    type: 'is-danger',
                    hasIcon: true
                })
        return
      }
      this.viewFilter = getScaleCallView();
      this.edit = scaleCallEdit();
      this.doSearch('APPTS');
      this.isdisableSend = false;
      this.isdisablephoto = true;
    },

    // wTicketPDF(){
    //   this.weightTicketItem.apptDateD = dateFormat.date(this.weightTicketItem.apptDate)
    //   this.weightTicketItem.ciDateT = dateFormat.time(this.weightTicketItem.ciDate)
    //   this.weightTicketItem.gwDateT = dateFormat.time(this.weightTicketItem.gwDate)
    //   this.weightTicketItem.twDateT = dateFormat.time(this.weightTicketItem.twDate)
    // 
    //   const doc = new jsPDF()
    //   doc.text(20,20,this.weightTicketItem.company)  
    //   doc.text(20,30,this.weightTicketItem.add1)
    //   doc.text(20,40,this.weightTicketItem.add2)
    //   doc.text(20,50,'Inbound')
    //   doc.text(20,60,'Receiving Window:'+ this.weightTicketItem.receivingWindows)
    //   doc.autoTable({
    //     margin: {top: 70},
    //     body: [
    //       ['Weight Ticket #:', this.weightTicketItem.scaleTicket +'/'+ this.weightTicketItem.scanWt],
    //       ['Appointment', this.weightTicketItem.apptDateD],
    //       ['IBS #', this.weightTicketItem.inboundShipment],
    //       ['PO #:', this.weightTicketItem.po],
    //       ['Appointment time:', this.weightTicketItem.apptTime],
    //       ['Check in time:', this.weightTicketItem.ciDateT],
    //       ['Scale in time:', this.weightTicketItem.gwDateT],
    //       ['Scale out time:', this.weightTicketItem.twDateT],
    //       ['Gross Weight:', parseInt(this.weightTicketItem.vgmWeight) + ' lb'],
    //       ['Tare Weight:', parseInt(this.weightTicketItem.tareWeight) + ' lb'],
    //       ['Net Weight:', parseInt(this.weightTicketItem.weight) + ' lb'],
    //       ['OOC Bales:', this.weightTicketItem.bales],
    //       ['LDPE Bales:', this.weightTicketItem.plasticCount],
    //       ['Plastic Weight:', this.weightTicketItem.plasticWeight],
    //       ['Pallets:', this.weightTicketItem.palletCount],
    //       ['Pallet Weight:', this.weightTicketItem.palletWeight],
    //       ['Material', this.weightTicketItem.matnr],
    //       ['Driver name:', this.weightTicketItem.moveInBy],
    //       ['Truck LIC Plate:', this.weightTicketItem.driverLP],
    //       ['Trailer Number:', this.weightTicketItem.containerNo],
    //       // ['Dispatcher:', this.weightTicketItem.createdBy],
    //     ],
    //   })

    //   var PDFBase64 = btoa(doc.output())
    //   api.post('/api/w/uploadPDF', {
    //   fileName: this.weightTicketItem.seqNo,
    //   imageBase64: PDFBase64,
    //   folder: "WTicket"
    //   })
    // },


    //User defined layout
    loadLayout()
    {
        if (this.selectedLayout != null && this.selectedLayout != "")
        {
            this.loadUserLayout(this.selectedLayout);
        }
    },
    
    async doReloadLayout()
    {
        this.loaded_default_allCols = [];
        await this.getLayoutNameList()
        .then(() => {
           this.loadUserLayout('',true, true)
           .then(() => {
              console.log(`user spec default layout: ${JSON.stringify(this.loaded_default_allCols)}`)
              if (this.loaded_default_allCols.length <= 0)
              {
                 this.loadUserLayout('',true, false)
                 .then(() => {
                    console.log(`general default layout: ${JSON.stringify(this.loaded_default_allCols)}`)
                    this.loaded_user_layout = this.loaded_default_allCols;
                 });
              } else {
                 this.loaded_user_layout = this.loaded_default_allCols;
              }
           });

        });
    },

    createLayout()
    {
        var update_layout = [];
        var process_report_module = 'OP_INBOUND_TM';
        this.loadUserLayout('',true,false)
        .then(() => {
           update_layout = this.loaded_default_allCols;
           this.$refs.CreateLayoutForm.openDialog(process_report_module, this.selectedLayout, update_layout, this.loaded_default_allCols, false, false);
        });

    },

    updateLayout()
    {
        var update_layout = [];
        var process_report_module = 'OP_INBOUND_TM';
        console.log(`selected layout: ${this.selectedLayout}`);
        this.loadUserLayout(this.selectedLayout)
        .then(() => {
           update_layout = this.loaded_user_layout;
           this.$refs.UpdateLayoutForm.openDialog(process_report_module, this.selectedLayout, update_layout, this.loaded_default_allCols, this.loaded_layout_userspec, this.loaded_layout_setdefault);
        });
    },

    docreate(id)
    {
       console.log(`return id: ${id}`);
       this.getLayoutNameList();
    },

    doupdate(id)
    {
       console.log(`return id: ${id}`);
    },

    async getLayoutNameList()
    {
        var p_layoutnames = [];
        this.layoutSearchRequest = getInitialLayoutSearchRequest();
        this.layoutSearchRequest.office = "FSI";
        this.layoutSearchRequest.reportModule = "OP_INBOUND_TM";
        this.layoutSearchRequest.layoutnamelist = true;
        this.layoutSearchRequest.onlyActive = true;
        //await api.post('/api/w/layout/Search', this.layoutSearchRequest)
        await newAPIPost('/api/w/layout/Search', this.layoutSearchRequest)
        .then((val) => {
           if (val != null && val.layoutNameList != null && val.layoutNameList.length > 0)
           {
               val.layoutNameList.forEach((it) => { 
                   if (!p_layoutnames.includes(it))
                   {
                      p_layoutnames.push(it);
                   }
               });
               this.userLayoutNameList = p_layoutnames;
               console.log(`name list: ${JSON.stringify(this.userLayoutNameList)}`);
           }
        });
    },

    async loadUserLayout(loadlayoutname,loaddefaultallcols,userspecific)
    {
         var p_items = [];
        console.log(`loadlayoutname: ${loadlayoutname}`);
        this.layoutSearchRequest = getInitialLayoutSearchRequest();
        this.layoutSearchRequest.office = "FSI";
        if (userspecific)
        {
            this.layoutSearchRequest.userSpecific = userspecific;
        }
        if (loaddefaultallcols)
        {
            this.layoutSearchRequest.setDefault = true;
        }
        if (loadlayoutname != null && loadlayoutname != "")
        {
            this.layoutSearchRequest.layoutName = loadlayoutname;
        }
        this.layoutSearchRequest.reportModule = "OP_INBOUND_TM";
        this.layoutSearchRequest.onlyActive = true;
        console.log(`search request: ${JSON.stringify(this.layoutSearchRequest)}`);
        //await api.post('/api/w/layout/Search', this.layoutSearchRequest)
        await newAPIPost('/api/w/layout/Search', this.layoutSearchRequest)
        .then((val) => {
           if (val != null && val.layoutInfoList != null && val.layoutInfoList.length > 0)
           {
               for (var i = 1; i < val.layoutInfoList.length + 1; i++)
               {
                   var p_index = i.toString();
                   var selectedrow = val.layoutInfoList.filter(it => it.colIndex == p_index);
                   if (selectedrow != null)
                   {
                      if (selectedrow.length > 0)
                      {
                         if (selectedrow[0].userSpecific != null)
                         {
                            this.loaded_layout_userspec = selectedrow[0].userSpecific;   
                         } else {
                            this.loaded_layout_userspec = false;
                         }
                         if (selectedrow[0].setDefault != null)
                         {
                            this.loaded_layout_setdefault = selectedrow[0].setDefault;
                         } else {
                            this.loaded_layout_setdefault = false
                         }
                         
                         
                         this.selectedLayout = selectedrow[0].layoutName;
                         console.log(`selected row: ${JSON.stringify(selectedrow[0])}`);
                         var p_row = reportLayoutElements();
                         p_row.orderIndex = i.toString();
                         p_row.colDataElement = selectedrow[0].colDataElement;
                         p_row.colHeaderText = selectedrow[0].colHeaderText;
                         p_row.colWidth = selectedrow[0].colWidth;
                         p_row.colDataType = selectedrow[0].colDataType;
                         if (!p_items.includes(p_row))
                         {
                            p_items.push(p_row);    
                         }
                      }
                   }   
                }
            }
            if (!loaddefaultallcols)
            {
               this.loaded_user_layout = [];
               this.loaded_user_layout = p_items;
               console.log(`layout p items: ${JSON.stringify(p_items)} and row count: ${p_items.length}`);
               console.log(`layout user: ${JSON.stringify(this.loaded_user_layout)} and row count: ${this.loaded_user_layout.length}`);
            } else {
              this.loaded_default_allCols = [];
              this.loaded_default_allCols = p_items;
              console.log(`default layout p items: ${JSON.stringify(p_items)} and row count: ${p_items.length}`);
              console.log(`layout default all: ${JSON.stringify(this.loaded_default_allCols)} and row count: ${this.loaded_default_allCols.length}`);
            }
        });
    },

    handleLayoutChanged(id)
    {
        console.log(`change layout id: ${id}`);
        this.selectedLayout = id;
        //this.doReloadLayout();
    },

  
    // end user defined layout


    sendSMS(){

      const change = this.getSelectedItems[0];
      const editItem = this.items.filter(it  => it.selected === true);
      const awshost = location.host;
      this.weightTicketItem = editItem[0];
 
       console.log("editItem length: " + editItem.length);
       if (editItem.length > 0)
       {
          console.log("isdisableSend: " + this.isdisableSend);
          if (this.isdisableSend === false)
          {
              this.$refs.DriverCallSMSForm.openDialog(editItem);
          }
          else
          {
             if (this.weightTicketItem.weight == null || this.weightTicketItem.weight == "")
             {
                this.$buefy.notification.open({
                    duration: 5000,
                    message: `The net weight has not ready yet!`,
                    position: 'is-top-right',
                    type: 'is-danger',
                    hasIcon: true
                })
                return
             }
             if (this.weightTicketItem.bales == null || this.weightTicketItem.bales == "")
             {
                this.$buefy.notification.open({
                    duration: 5000,
                    message: `Shipments is missing bales!`,
                    position: 'is-top-right',
                    type: 'is-danger',
                    hasIcon: true
                })
                return
             }
              this.weightTicket();

              console.log("select item trucker name: " + _(this.items[0]).trucker_name);
              console.log("editItem: " + editItem[0].moveInBy + " phonenum: " + editItem[0].driverPh + " IBS: " + editItem[0].inboundShipment);
              //const url = "https://named-account-web-dev.s3.us-west-2.amazonaws.com/PDF/WTicket/" + editItem[0].inboundShipment + ".pdf";
              var url = "https://named-account-web-dev.s3.us-west-2.amazonaws.com/PDF/WTicket/" + editItem[0].seqNo + ".pdf";
              if (awshost.includes("-qas."))
              {
                 url = "https://named-account-web-qas.s3.us-west-2.amazonaws.com/PDF/WTicket/" + editItem[0].seqNo + ".pdf";
              }
              if (awshost.includes("-prd."))
              {
                 url = "https://named-account-web-prd.s3.us-west-2.amazonaws.com/PDF/WTicket/" + editItem[0].seqNo + ".pdf";
              }
              //const url = "https://named-account-web-dev.s3.us-west-2.amazonaws.com/PDF/WTicket/200894538.pdf";
              console.log("inbound::sendSMS::awshost: " + awshost);
              console.log("url: " + url);
              // fetch(url)
              // .then( response => {
              //    if (response.statusText === "OK")
              //    {
              //      console.log("url existed");
                   this.$refs.DriverSMSForm.openDialog(editItem);
              //    }
              //    else
              //    {
              //      console.log("url not found");
              //      this.$buefy.notification.open({
              //          duration: 5000,
              //          message: `Weight Ticket Link is not ready!`,
              //          position: 'is-top-right',
              //          type: 'is-danger',
              //          hasIcon: true
              //     })
              //    }
              //  }
              // );
          }
          /*
          const pdfExists = this.urlExists(url)
          //.then( it => {
          console.log("pdfExists: " + pdfExists);
          if (pdfExists === false){
             this.$buefy.notification.open({
                      duration: 5000,
                      message: `Weight Ticket Link is not ready!`,
                      position: 'is-top-right',
                      type: 'is-danger',
                      hasIcon: true
                  })
          return
          };
          this.$refs.DriverSMSForm.openDialog(editItem);
          //}
          //);
          */
       }
       else
       {
          alert("Please select at least one entry!");
       }
    },
    smsLog(){
       const change = this.getSelectedItems[0];
       const editItem = this.items.filter(it  => it.selected === true);
       console.log("editItem length: " + editItem.length);
       console.log("select item trucker name: " + _(this.items[0]).trucker_name);
       console.log("editItem: " + editItem[0].moveInBy + " phonenum: " + editItem[0].driverPh + " IBS: " + editItem[0].seqNo);
       this.$refs.DriverSMSLogForm.openDialog(editItem);
    },
    takeBOLPic(){
       const editItem = this.items.filter(it  => it.selected === true);
       if (editItem.length != 1)
       {
           this.$buefy.notification.open({
                      duration: 5000,
                      message: `Please select 1 entry!`,
                      position: 'is-top-right',
                      type: 'is-danger',
                      hasIcon: true
                  })
           return

       }

       this.$refs.WebCamForm.openDialog(editItem);
    },
    scaleGW(){
      const editItem = this.items.filter(it  => this.hasBeenChanged(it));
      if (editItem.length != 0)
      {
        this.$buefy.notification.open({
                    duration: 5000,
                    message: `Please save your works first!`,
                    position: 'is-top-right',
                    type: 'is-danger',
                    hasIcon: true
                })
        return
      }
      this.viewFilter = getScaleGWView();
      this.edit = scaleGWEdit();
      this.loadUserLayout('TM_DEFAULT_GW');
      this.doSearch('APPTGW');
      this.isdisableSend = true;
      this.isdisablephoto = true;
    },
    scaleTW(){
      const editItem = this.items.filter(it  => this.hasBeenChanged(it));
      if (editItem.length != 0)
      {
        this.$buefy.notification.open({
                    duration: 5000,
                    message: `Please save your works first!`,
                    position: 'is-top-right',
                    type: 'is-danger',
                    hasIcon: true
                })
        return
      }
      this.viewFilter = getScaleTWView();
      this.edit = scaleTWEdit();
      this.loadUserLayout('TM_DEFAULT_TW');
      this.doSearch('APPTTW');
      this.isdisableSend = true;
      this.isdisablephoto = true;
    },
    transferTicket(){
      const item = _(this.items).filter((it) => it.selected);
      this.transferTicketItem = item[0];
      // if (this.hasBeenChanged(this.transferTicketItem))
      // {
      //   this.$buefy.notification.open({
      //               duration: 5000,
      //               message: `Please save this shipment first!`,
      //               position: 'is-top-right',
      //               type: 'is-danger',
      //               hasIcon: true
      //           })
      //   return
      // }
      if (this.transferTicketItem.receivingWindows == '185' || this.transferTicketItem.receivingWindows == '187' || this.transferTicketItem.receivingWindows == '202')
      {
        this.transferTicketItem.company = 'FSI Transloading - 1495 Judson Ave Long Beach, CA 90813'
      }
      if (this.transferTicketItem.receivingWindows == '186' || this.transferTicketItem.receivingWindows == '188' || this.transferTicketItem.receivingWindows == '201' || this.transferTicketItem.receivingWindows == '203')
      {
        this.transferTicketItem.company = 'FSI Transloading - 936 Mahar Avenue, Wilmington, CA 90744'  
      }
      this.transferTicketItem.add1 =  'PLEASE READ BELOW AND SIGN BELOW TO ACKNOWLEDGE'
      this.transferTicketItem.add2 =  'ATTENTION DRIVER:PLEASE SLIDE AXEL ALL THE WAY BACK AND LOCK TANDEM'
      this.transferTicketItem.add3 =  'IMPORTANT!!PLEASE HAND THIS TICKET TO THE DOCK ASSOCIATE,'
      this.transferTicketItem.add4 =  'THE TICKET WILL BE RETURNED TO YOU AFTER YOUR TRAILER IS UNLOADED.'
      this.transferTicketItem.add5 =  'ONCE EMPTY PLEASE STOP AT HTE SCALHOUSE TO GET YOUR EMPTY WEIGHT,'
      this.transferTicketItem.add6 =  'YOU MUST RETURN THIS TICKET IN EXCHANGE FOR YOUR PAPERWORK.'
      this.transferTicketItem.add7 =  'NO SMOKING AND NO CELL PHONE USE PERMITTED INSIDE THE PREMISES WHILE DRIVING'
      this.transferTicketItem.add8 =  'FOR YOUR SAFETY, PLEASE STAY IN YOUR VEHICAL AT ALL TIMES(CAUTION: FOR FORKLIFT & PEDESTRIAN'
      this.transferTicketItem.add9 =  'AND MOVING VEHICLE IN THE YARD). FAILURE TO COMPLY MAY RESULT YOU BEING REMOVED IMMEDIATLEY.'
      this.transferTicketItem.add10 = 'DO NOT SHIFT YOUR TANDENS ON THE SCALE!!!'
      this.transferTicketItem.add11 = '**SAFETY VEST MUST BE WORN AT ALL TIMES**'
      this.transferTicketItem.add12 = 'HAZARD WARNING :'
      this.transferTicketItem.add13 = '  DRIVERS, BE AWARE TO TAKE CARE WHEN OPENING THE DOORS ON YOUR TRAILER IN PREPARATION TO GET OFFLOADED. THERE IS A CHANCE YOUR CARGO MAY HAVE SHIFTED DURING TRANSIT AND THE IS A RISK IT MAY FALL OUT WHEN THE DOORS ARE OPENED.'

      //Allen request on 1/19/2026 - Joseph confirmed
      if (this.transferTicketItem.vgmWeight == null || this.transferTicketItem.vgmWeight == "")
      {
        this.$buefy.notification.open({
                    duration: 5000,
                    message: `Shipment has not scaled gross weight yet!`,
                    position: 'is-top-right',
                    type: 'is-danger',
                    hasIcon: true
                })
        return
      }

      this.transferTicketItem.deductedVGMWeight = parseInt(this.transferTicketItem.vgmWeight);
      if (this.transferTicketItem.gwYgNo.trimEnd() == "FlatGross")
      {
          if (this.transferTicketItem.gwYgWeight != null && this.transferTicketItem.gwYgWeight != "")
          {
              if (parseInt(this.transferTicketItem.gwYgWeight) > 0)
              {
                  var t_gwygweight = parseInt(this.transferTicketItem.gwYgWeight)
                  this.transferTicketItem.deductedVGMWeight -= t_gwygweight; 
              }
          }
      }
      console.log(`transfer ticket deductedVGMWeight: ${this.transferTicketItem.deductedVGMWeight}`);

      this.transferTicketStatus = true;
      this.isdisableSend = true;
      this.isdisablephoto = true;
    },
    weightTicket(){
      const item = _(this.items).filter((it) => it.selected);
      this.weightTicketItem = item[0];
      // if (this.hasBeenChanged(this.transferTicketItem))
      // {
      //   this.$buefy.notification.open({
      //               duration: 5000,
      //               message: `Please save this shipment first!`,
      //               position: 'is-top-right',
      //               type: 'is-danger',
      //               hasIcon: true
      //           })
      //   return
      // }
      console.log (JSON.stringify(this.weightTicketItem)) ; 
      if (this.weightTicketItem.receivingWindows == '185' || this.weightTicketItem.receivingWindows == '187' || this.weightTicketItem.receivingWindows == '202')
      {
        this.weightTicketItem.company = 'FSI Long Beach'
        this.weightTicketItem.add1 = '1495 Judson Ave Long Beach, CA 90813'
        this.weightTicketItem.add2 = 'Tel:(562)495-1936'
        this.weightTicketItem.weightmaster4 = 'Consignee: FSI TRANSLOADING INC.'
        this.weightTicketItem.weightmaster5 = 'Weighed at: 1465 Judson Ave., Long Beach, CA 90813 USA'
      }
      if (this.weightTicketItem.receivingWindows == '186' || this.weightTicketItem.receivingWindows == '188' || this.weightTicketItem.receivingWindows == '201' || this.weightTicketItem.receivingWindows == '203')
      {
        this.weightTicketItem.company = 'FSI Wilmington' 
        this.weightTicketItem.add1 = '936 Mahar Avenue, Wilmington, CA 90744'
        this.weightTicketItem.add2 = 'Tel:(562)495-1936'    
        this.weightTicketItem.weightmaster4 = 'Consignee: FSI TRANSLOADING INC.'
        this.weightTicketItem.weightmaster5 = 'Weighed at: 936 Mahar Ave., Wilmington CA 90744 USA'
      }
      this.weightTicketItem.weightmaster1 = 'WEIGHTMASTER CERTIFICATE' 
      this.weightTicketItem.weightmaster2 = 'THIS IS TO CERTIFY that the following described commodity was weighed, measured, or counted by a weighmaster, whose signature is on this certificate, who is a recognized authority of accuracy, as prescribed by Chapter 7 (commencing with Section 12700) of Division 5 of the California business and Professions Code, administered by the Division of Measurement Standards of the California Department of Food and Agriculture.' ;
      this.weightTicketItem.weightmaster3 = 'LICENSE NO.: 014950'

      //setup YG deduction for Gross and Tare when user selected CRST Flatbed
      //Allen request - Joseph and Reg confirmed ok
      this.weightTicketItem.deductedVGMWeight = parseInt(this.weightTicketItem.vgmWeight);
      if (this.weightTicketItem.gwYgNo.trimEnd() == "FlatGross")
      {
         if (this.weightTicketItem.gwYgWeight != null && this.weightTicketItem.gwYgWeight != "")
         {
             if (parseInt(this.weightTicketItem.gwYgWeight) > 0)
             {
                var t_gwygweight = parseInt(this.weightTicketItem.gwYgWeight)
                this.weightTicketItem.deductedVGMWeight -= t_gwygweight; 
             }
         }
      }
      console.log(`deductedVGMWeight: ${this.weightTicketItem.deductedVGMWeight}`);

      //this.weightTicketItem.deductedTareWeight = parseInt(this.weightTicketItem.tareWeight);
      //if (this.weightTicketItem.twYgNo.trimEnd() == "FlatTare")
      //{
      //   if (this.weightTicketItem.twYgWeight != null && this.weightTicketItem.twYgWeight != "")
      //   {
      //       if (parseInt(this.weightTicketItem.twYgWeight) > 0)
      //       {
      //          var t_twygweight = parseInt(this.weightTicketItem.twYgWeight);
      //          this.weightTicketItem.deductedTareWeight -= t_twygweight; 
      //       }
      //   }
      //}
      //console.log(`deductedTareWeight: ${this.weightTicketItem.deductedTareWeight}`);

      if (this.weightTicketItem.weight == null || this.weightTicketItem.weight == "")
      {
        this.$buefy.notification.open({
                    duration: 5000,
                    message: `The net weight has not ready yet!`,
                    position: 'is-top-right',
                    type: 'is-danger',
                    hasIcon: true
                })
        return
      }
      if (this.weightTicketItem.bales == null || this.weightTicketItem.bales == "")
      {
        this.$buefy.notification.open({
                    duration: 5000,
                    message: `Shipments is missing bales!`,
                    position: 'is-top-right',
                    type: 'is-danger',
                    hasIcon: true
                })
        return
      }
      if (this.weightTicketItem.qcIssue == null || this.weightTicketItem.qcIssue == "")
      {
        if (this.weightTicketItem.inboundStatus != "R")
        {
          //api.post("/api/w/fsi/WebSaveInbound", {
          newAPIPost("/api/w/fsi/WebSaveInbound", {
                              mode: 'APPTTR',
                              username : this.getUserProfile.username,
                              apptNo: this.weightTicketItem.apptNo,
                              apptSeq: this.weightTicketItem.apptSeq,
                              inboundSeq: this.weightTicketItem.inboundSeq,
                              recDate : dateFormat.getLocalDateOnly(moment().toDate()) + 'T' + dateFormat.time(moment().toDate()),
                            })
                            .then(() => {
                              this.$store.commit('clearApiError');
                              // this.wTicketPDF();
                              this.weightTicketStatus = true;
          });
        }
        else
        {
          // this.wTicketPDF();
          this.weightTicketStatus = true;
        }
      }
      else
      {
        this.$buefy.dialog.confirm({
                    title: 'QC Warning',
                    message: 'Shipment has QC issue!',
                    confirmText: 'Confirm',
                    type: 'is-danger',
                    hasIcon: true,
                    onConfirm: () => {
                      if (this.weightTicketItem.inboundStatus != "R")
                        {
                          //api.post("/api/w/fsi/WebSaveInbound", {
                          newAPIPost("/api/w/fsi/WebSaveInbound", {
                              mode: 'APPTTR',
                              username : this.getUserProfile.username,
                              apptNo: this.weightTicketItem.apptNo,
                              apptSeq: this.weightTicketItem.apptSeq,
                              inboundSeq: this.weightTicketItem.inboundSeq,
                              recDate : dateFormat.getLocalDateOnly(moment().toDate()) + 'T' + dateFormat.time(moment().toDate()),
                            })
                            .then(() => {
                              this.$store.commit('clearApiError');
                              // this.wTicketPDF();
                              this.weightTicketStatus = true;
                            });
                        }
                        else
                        {
                          // this.wTicketPDF();
                          this.weightTicketStatus = true;
                        }
                    }
                })
      }
      this.isdisableSend = true;
      this.isdisablephoto = true;
      
    },
    getWtForSAP(item) {
       if (item.scanWt == null || item.scanWt == "") {
          return item.scaleTicket;
       } else {
          return item.scanWt;
       }
    },
    getSummary() {
      this.sideBar = true;
    },
    hidesideBar() {
      this.sideBar = false;
    },
    async getScaleWeight(){

      //this.scalecontrol = await api.post('/api/w/app/list', this.scalecontrolSearch);
      this.scalecontrol = await newAPIPost('/api/w/app/list', this.scalecontrolSearch);
      const scale0 = this.scalecontrol[0];
      const scale1 = this.scalecontrol[1];
      const scale2 = this.scalecontrol[2];
      const scale3 = this.scalecontrol[3];
      const scale4 = this.scalecontrol[4];


      const selectedItem = this.getSelectedItems[0];
      //console.log(`scaling selected item: ${JSON.stringify(selectedItem)}`);
      //console.log(`user location: ${this.p_user_location}`);
      //this.p_user_location = '"WILMINGTON"';
      //if (this.p_office_ips.length < 1)
      console.log(`userprofile: ${JSON.stringify(this.getUserProfile)}`);
      if (this.getUserProfile.recWindow != "99")
      {
        if (this.getUserAllowRecWin == null || this.getUserAllowRecWin.length < 1)
        {
            await this.$store.dispatch('checkUserLocation')
            .then(() => {
              if (this.getUserAllowRecWin == null || this.getUserAllowRecWin.length < 1)
              {
                 this.$buefy.notification.open({
                      duration: 5000,
                      message: `Has no info for Rec window restriction to check, please refresh browser`,
                      position: 'is-top-right',
                      type: 'is-danger',
                      hasIcon: true
                 })
                 return;
              }
              var p_allow_rec_win = this.getUserAllowRecWin;
              console.log(`p_allow_rec_win: ${JSON.stringify(this.getUserAllowRecWin)}`);
              if (!p_allow_rec_win.includes(selectedItem.receivingWindows))
              {
                 this.$buefy.notification.open({
                      duration: 5000,
                      message: `${this.p_user_location} user not allow scaling load from rec window: ${selectedItem.receivingWindows}`,
                      position: 'is-top-right',
                      type: 'is-danger',
                      hasIcon: true
                 })
                 return;
              }
              //if (this.edit.mode == 'APPTGW')
              //{
              //    this.$refs.ScaleGrossWeight.openDialog(selectedItem, scale0, scale1, scale2, scale3, scale4);
              //}
              //if (this.edit.mode == 'APPTTW')
              //{
              //     this.$refs.ScaleTareWeight.openDialog(selectedItem, scale0, scale1, scale2, scale3, scale4);
               //}
            });
        }  else {
            var p_allow_rec_win = this.getUserAllowRecWin;
            console.log(`p_allow_rec_win: ${JSON.stringify(this.getUserAllowRecWin)}`);
            if (!p_allow_rec_win.includes(selectedItem.receivingWindows))
            {
                this.$buefy.notification.open({
                      duration: 5000,
                      message: `${this.p_user_location} user not allow scaling load from rec window: ${selectedItem.receivingWindows}`,
                      position: 'is-top-right',
                      type: 'is-danger',
                      hasIcon: true
                })
                return;
            }
            //if (this.edit.mode == 'APPTGW')
            //{
            //    this.$refs.ScaleGrossWeight.openDialog(selectedItem, scale0, scale1, scale2, scale3, scale4);
            //}
            //if (this.edit.mode == 'APPTTW')
            //{
            //    this.$refs.ScaleTareWeight.openDialog(selectedItem, scale0, scale1, scale2, scale3, scale4);
            //}
        }  
      }   
      if (this.edit.mode == 'APPTGW')
      {
          this.$refs.ScaleGrossWeight.openDialog(selectedItem, scale0, scale1, scale2, scale3, scale4);
      }
      if (this.edit.mode == 'APPTTW')
      {
          this.$refs.ScaleTareWeight.openDialog(selectedItem, scale0, scale1, scale2, scale3, scale4);
      }


      // if (this.getUserAllowRecWin.length < 1)
      // {
      //   this.$buefy.notification.open({
      //               duration: 5000,
      //               message: `Has no info for Rec window restriction to check, please refresh browser`,
      //               position: 'is-top-right',
      //               type: 'is-danger',
      //               hasIcon: true
      //           })
      //     return;
      // }
      // // if (this.p_user_location === 'ACNI')
      // // {
      // //     //alert(`${this.p_user_location} user not allow scaling load from rec window: ${selectedItem.receivingWindows}`);
      // //     this.$buefy.notification.open({
      // //               duration: 5000,
      // //               message: `${this.p_user_location} user not allow scaling load from rec window: ${selectedItem.receivingWindows}`,
      // //               position: 'is-top-right',
      // //               type: 'is-danger',
      // //               hasIcon: true
      // //           })
      // //     return;
      // // }
      // // if (!this.p_office_ips.has(this.p_user_location))
      // // {
      // //     this.$buefy.notification.open({
      // //               duration: 5000,
      // //               message: `${this.p_user_location} user not allow scaling load from rec window: ${selectedItem.receivingWindows}`,
      // //               position: 'is-top-right',
      // //               type: 'is-danger',
      // //               hasIcon: true
      // //           })
      // //     return;
      // // }
      // //var p_allow_rec_win = this.p_office_ips.get(this.p_user_location);
      // var p_allow_rec_win = this.getUserAllowRecWin;
      // console.log(`p_allow_rec_win: ${JSON.stringify(this.getUserAllowRecWin)}`);
      // //console.log(`allow rec win: ${JSON.stringify(p_allow_rec_win)}`);
      // // if (this.p_user_location === 'LONG BEACH' 
      // //      && ( this.p_wil_rec_wins.includes(selectedItem.receivingWindows)))
      // if (!p_allow_rec_win.includes(selectedItem.receivingWindows))
      // {
      //     //alert(`${this.p_user_location} user not allow scaling load from rec window: ${selectedItem.receivingWindows}`);
      //     this.$buefy.notification.open({
      //               duration: 5000,
      //               message: `${this.p_user_location} user not allow scaling load from rec window: ${selectedItem.receivingWindows}`,
      //               position: 'is-top-right',
      //               type: 'is-danger',
      //               hasIcon: true
      //           })
      //     return;
      // }
      // // if (this.p_user_location === 'WILMINGTON' 
      // //      && ( this.p_lgb_rec_wins.includes(selectedItem.receivingWindows)))
      // // {
      // //     //alert(`${this.p_user_location} user not allow scaling load from rec window: ${selectedItem.receivingWindows}`);
      // //     this.$buefy.notification.open({
      // //               duration: 5000,
      // //               message: `${this.p_user_location} user not allow scaling load from rec window: ${selectedItem.receivingWindows}`,
      // //               position: 'is-top-right',
      // //               type: 'is-danger',
      // //               hasIcon: true
      // //           })
      // //     return;
      // // }
      // if (this.edit.mode == 'APPTGW')
      // {
      //   this.$refs.ScaleGrossWeight.openDialog(selectedItem, scale0, scale1, scale2, scale3, scale4);
        
      // }
      
      // if (this.edit.mode == 'APPTTW')
      // {
      //   this.$refs.ScaleTareWeight.openDialog(selectedItem, scale0, scale1, scale2, scale3, scale4);
      // }
      
    },
    toggleItemPhoto(item) {
        this.$refs.BolPhotoZoomForm.openDialog(
        //this.$refs.BolPhotoForm.openDialog(
          `Photo.zip`,
          item.apptNo,
          "BWT",
          photoMetaLoading,
          { seqNo: item.apptNo,sortKey : 'BWT' },
          item.inboundStatus == 'R' ? false : true
        );
    },
    updatePhoto(url, seq){
      const item = _(this.items)
          .find(it => it.apptNo === seq);
      item.bolScan = url;
    },
    filterBar(){
      this.isFilterModalShowing = true;
    },

    ticketManagement() {
      console.log('Ticket Management');
      this.$refs.TicketManagement.openDialog(this.getSelectedItems[0]);
    },

    inboundRemark() {
      console.log('Inbound Remark');
      this.$refs.InboundRemarkForm.openDialog(this.getSelectedItems[0]);
      //this.doSearch('0');
    },

    updateTicket(bales, upgrade, upBales, scanWt) {
      this.saveApptTM();
      console.log(bales);
      console.log(upgrade);
      console.log(upBales);
      console.log(scanWt);
    },

    updateRemark(remark) {
      //console.log("remark: " + remark);
      //console.log("selected item: " + this.getSelectedItems[0]);
      const p_apptNo = this.getSelectedItems[0].apptNo;
      const p_ibs = this.getSelectedItems[0].inboundShipment;
      this.items.forEach(
         (it) => {
             if (it.apptNo == p_apptNo && it.inboundShipment == p_ibs) {
                 it.loadRemark = remark;
                 //console.log("get the item: " + JSON.stringify(it));
                 return;
             }
         }
      )
    },


    toggleContainerCopy(element) {
      this.containerCopy = true;
      setTimeout(() => {
        this.containerCopy = false;
      }, 2000);
      var el = document.createElement("textarea");
      el.value = element;
      el.setAttribute("readonly", "");
      el.style = { position: "absolute", left: "-9999px" };
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
    },
 
  doDownloadExcel(){
       var row = [];
       var rows = [];
       const special_colElement = ['inboundStatus','originalGW','originalTW','scanWtLink','ticketSAP','tareWeight','vgmWeight'];

       this.items.forEach((item) => {
          this.loaded_user_layout.forEach((it) => {
              if (it.colDataType == 'DATE')
              {
                  row.push(dateFormat.date(item[it.colDataElement]));
              }
              if (it.colDataType == 'TIME')
              {
                  row.push(dateFormat.time(item[it.colDataElement]));
              }
              if (it.colDataElement == 'inboundStatus' && it.colDataType == 'STATUS_OPEN')
              {
                 if (item[it.colDataElement] == 'O')
                 {
                    row.push('X');
                 } else {
                    if (item[it.colDataElement] == 'C')
                    {
                        row.push('O');
                    } else {
                       row.push('');
                    }
                 }
              }
              if (it.colDataElement == 'inboundStatus' && it.colDataType == 'STATUS_CHECKIN')
              {
                 if (item[it.colDataElement] == 'C')
                 {
                     row.push('X');
                 } else {
                    row.push('');
                 }
              }
              if (it.colDataElement == 'inboundStatus' && it.colDataType == 'STATUS_REC')
              {
                  if (item[it.colDataElement] == 'R')
                  {
                      row.push('X');
                  } else {
                      row.push('');
                  }
              }
              if (it.colDataElement == 'inboundStatus' && it.colDataType == 'STATUS_NOSHOW')
              {
                  if (item[it.colDataElement] == 'N')
                  {
                      row.push('X');
                  } else {
                     row.push('');
                  }
              }
              if (it.colDataElement == 'inboundStatus' && it.colDataType == 'STATUS_DRIVERLEFT')
              {
                  if (item[it.colDataElement] == 'L')
                  {
                      row.push('X');
                  } else {
                      row.push('');
                  }
              }
              if (it.colDataElement == 'tareWeight' || it.colDataElement == 'vgmWeight')
              {
                  if (item[it.colDataElement] != null && item[it.colDataElement] != '')
                  {
                      row.push(parseInt(item[it.colDataElement]).toString());
                  } else {
                      row.push('');
                  }
              }
              if (it.colDataElement == 'originalGW')
              {
                  if (item[it.colDataElement] != null && item[it.colDataElement] != '' && parseInt(item.vgmWeight) != parseInt(item[it.colDataElement]))
                  {
                      row.push('X');
                  } else {
                      row.push('');
                  }
              }
              if (it.colDataElement == 'originalTW')
              {
                  if (item[it.colDataElement] != null && item[it.colDataElement] != '' && parseInt(item.tareWeight) != parseInt(item[it.colDataElement]))
                  {
                      row.push('X');
                  } else {
                      row.push('');
                  }
              }
              if (it.colDataElement == 'scanWtLink')
              {
                 if (item[it.colDataElement] != null)
                 {
                    row.push('1 photos');
                 } else {
                    row.push('0 photo');
                 }
              }
              if (it.colDataElement == 'ticketSAP')
              {
                 row.push(this.getWtForSAP(item)); 
              }
              if ((it.colDataType != 'DATE' && it.colDataType != 'TIME') && !special_colElement.includes(it.colDataElement))
              {
                  row.push(item[it.colDataElement]);
              } 

          })
          rows.push(row);
          row = [];
       });

       const request = toGenerateExcelRequest(
          this.$el.querySelector('.data-table-container .inner-container'),
          'Inbound_Scaling.xls',
          1,
        );
        request.headers = _(request.headers).take(this.loaded_user_layout.length);
        request.rows = _(rows);

          //request.heads = _(request.heads).take(82);
          // request.rows = _(this.items)
          // .map(item => [
          // item.transloadingYard,
          //   item.receivingWindows,
          //   item.dockType,
          //   item.apptNo,
          //   dateFormat.date(item.apptDate),
          //   item.apptTime,
          //   item.inboundShipment,
          //   item.matnr,
          //   item.matnr_desc,
          //   item.salesOffice,
          //   item.block, 
          //   item.inboundStatus == 'O' ? 'X' : item.inboundStatus == 'C' ? 'O' : null, 
          //   item.inboundStatus == 'C' ? 'X' : null,
          //   item.inboundStatus == 'R' ? 'X' : null,
          //   item.inboundStatus == 'N' ? 'X' : null,
          //   item.inboundStatus == 'L' ? 'X' : null,
          //   item.workIn,
          //   item.salesOffice,
          //   item.externalTrucker,
          //   item.moveInBy,
          //   item.driverPh,
          //   item.driverLP,
          //   item.containerNo,
          //   dateFormat.date(item.ciDate),
          //   dateFormat.time(item.ciDate),
          //   item.scaleCalled,
          //   dateFormat.time(item.callTime), 
          //   item.gwStation, 
          //   item.scaleTicket,
          //   item.scanWt,
          //   item.scanWt == null ? item.scaleTicket : item.scanWt,
          //   item.scanWtLink == null ? '0 photo' : '1 photo',
          //   item.vgmWeight,
          //   dateFormat.date(item.gwDate),
          //   dateFormat.time(item.gwDate),
          //   dateFormat.time(item.gwDateWeb),
          //   item.originalGW && item.originalGW != '' && item.originalGW != item.vgmWeight? 'X' : '',
          //   item.gwYgNo,
          //   item.gwYgWeight,
          //   item.twStation,
          //   item.tareWeight,
          //   dateFormat.date(item.twDate),
          //   dateFormat.time(item.twDate),
          //   dateFormat.time(item.twDateWeb),
          //   item.originalTW && item.originalTW != '' && item.originalTW != item.tareWeight ? 'X' : '',
          //   item.weight,
          //   item.totalHours,
          //   item.twYgNo,
          //   item.twYgWeight,
          //   item.plasticCount,
          //   item.palletCount,
          //   item.plasticWeight,
          //   item.palletWeight,                                     
          //   item.bol,
          //   item.bolWT,
          //   item.bolScan != null ? '1 photo' : '0 photo',
          //   item.bolGW,
          //   item.bolTW,
          //   item.bolNW,
          //   item.weightDifferent,
          //   item.bales,
          //   item.looseCount,
          //   item.qcIssue,
          //   //item.moisture,
          //   item.upgradeSuggestion,
          //   item.upgradeBales,
          //   item.loadRemark,
          //   item.ibs_type,
          //   //item.route,
          //   item.route_desc,
          //   item.trucker_name,
          //   //item.supplier,
          //   item.supplier_name,
          //   item.inco1,
          //   item.po,
          //   item.po_lsd,
          //   item.ac_name,
          //   item.buyer_name,
          //   item.sapStatus,
          //   dateFormat.date(item.unloadStartTimeStamp),
          //   dateFormat.time(item.unloadStartTimeStamp),
          //   dateFormat.date(item.unloadEndTimeStamp),
          //   dateFormat.time(item.unloadEndTimeStamp),
          //   item.uploadMobileUser,
            
          // ]);
        this.$store.dispatch('generateExcel', request)
          .then((res) => {
            window.open(res.url, 'blank');
          });
        this.isdisableSend = true; 
        this.isdisablephoto = true; 
      },

      urlExists(url) {
         console.log("url: " + url);
         fetch(url)
         .then( () => {
            if (response.statusText === "OK")
            {
               console.log("url existed");
               return true;
            }
            else
            {
               console.log("url not found");
               return false;
            }

         }
         )
         /*
         const response = await fetch(url);
         //const data = await response.json();
         const status = response.statusText;
         console.log("status: " + status);
         if (status === "OK") {
             console.log("urlExists: true"); 
             return true;
         }
         else { 
             console.log("urlExists: false"); 
             return false;
         }
         */
      },

      //}
  },
};
</script>
